import { Spine } from '@esotericsoftware/spine-pixi-v7'
import * as PIXI from "pixi.js";
import { pixiApp } from "./initializePixi.js";
import { gsap } from "gsap";
import { PixiPlugin } from "gsap/PixiPlugin";
import { menuPopUp } from './menuPopUp.js';
import { spinButton } from './spinButton.js';
import { betPanel } from './betPanel.js';
import { roundPanel } from './roundPanel.js';
import tuktukDemoState, { globalData } from './globalData.js';
import { gameStates } from './gameStates.js';
import { obstacles } from './obstacles.js';
import { processSpinResult } from './processSpinResult.js';
import { config } from './appConfig.js';
import { checkForPendingGame, isOnline, setLanguage } from './gameService.js';
import { winScreen } from './winScreen.js';
import { meter } from './meter.js';
import { playContinue, playEngineLoop, playEngineStart, playJeepneyLeft, playJeepneyRight, playMainBg, playOff, playOn, playPopUpOpen } from './soundManager.js';
import { popUp } from './popUp.js';
import { tweenFadeAppear } from './utility.js';
import { turboData } from './turboData.js';
import { playDisable, playMinus, playPlus } from './soundManager.js';
import { setupCoins } from "./coins.js";
import { loader } from "./loader.js";
import { jackpotPanel } from './jackpotPanel.js';
import { bulbMeter } from './bulbMeter.js';


gsap.registerPlugin(PixiPlugin);
// PixiPlugin.registerPIXI(PIXI);

let uiCreated = false;
export let turboGraphic;
export let autoGraphic;
let leavesSpine;

const aspectRatio = 9 / 16;
const containers = {
  rootContainer: new PIXI.Container(),
  bgContainer: new PIXI.Container(),
  pageContainer: new PIXI.Container(),
  imageContainer: new PIXI.Container(),
  coinsContainer: new PIXI.Container()
};

const gameTextStyle = new PIXI.TextStyle({
  dropShadow: true,
  dropShadowAngle: 0,
  dropShadowBlur: 0,
  dropShadowColor: 0,
  dropShadowDistance: 0,
  stroke: 0,
  strokeThickness: 6,
  fill: "#ffffff",
  fontFamily: "Arial",
  fontSize: 70,
  fontWeight: "bolder",
  align: "center",
});

const gameAssets = {
  jeepney: null,
  chicken: null,
  jeepComplete: true,
  autoJeepComplete: true,
  turboJeepComplete: true,
  transition: null,

  gameScreen2: null,

  amazing: null,
  demoButton: null,

  clickText: null,

  timerTween: [],

  startText: null,
  startTextContainer: null,

  autoplayInprogress: false,

  gameScreen: null,
  background: null,
  coin: null,
  cauldron: null,
  foreground: null,
  midground: null,
  ambientBackground: null,
  birds: null,
  sky: null,

  characterL: null,
  characterR: null,
  characterC: null,

  menubarButton: null,
  gameUI: null,
  roundPanel: null,

  balanceValueText: null,
  totalBetValueText: null,
  balanceIcon: null,

  autoPlayNormal: null,
  turboNormal: null,
  autoplayEnabled: null,
  turboEnabled: null,

  PageMask: null,
  selected: null,
  skip: null,
  currentPage: null,
  page: [],
  pageIcons: [],

  arrowLeftDisabled: null,
  arrowLeftHover: null,
  arrowLeftEnabled: null,
  arrowRightDisabled: null,
  arrowRightHover: null,
  arrowRightEnabled: null,

  meterHolder: null,
  meter: null,
  meterMask: null,

  loadingScreen: null,
  cheatMessage: null,
  pointerDown: false,
  startPointerY: 0,
  startContainerY: 0,

  coin1: null,
  coin2: null,
  coin3: null,
  coin4: null,
  coin5: null,
  coin6: null,
  coin7: null,
  coin8: null,
  coin9: null,
  coin10: null,
  coin11: null,
  coin12: null,
  coin13: null,
  coin14: null,
  coin15: null,
  coin16: null,
  coin17: null,
  coin18: null,
  withJackpotEng: [
    "p1_content",
    "p2_content",
    "p3_content",
    "p4_content",
    "p4b_content",
    "p4c_content",
    "p5_content",
    "p6_content",
    "p7_content",
    "p9_content",
    'p10_content',
    "p8_content01",
    "p8_content02",
    "p8_content03",
  ],
  withoutJackpotEng: [
    "p1_content",
    "p2_content",
    "p3_content",
    "p4_content",
    "p4b_content",
    "p4c_content",
    "p5_content",
    "p6_content",
    "p9_content",
    'p10_content',
    "p8_content01",
    "p8_content02",
    "p8_content03",
  ],
  withJackpotTag: [
    "p1_content_tag",
    "p2_content_tag",
    "p3_content_tag",
    "p4_content_tag",
    "p4b_content_tag",
    "p4c_content_tag",
    "p5_content_tag",
    "p6_content_tag",
    "p7_content_tag",
    "p9_content_tag",
    'p10_content_tag',
    "p8_content01_tag",
    "p8_content02_tag",
    "p8_content03_tag"
  ],
  withoutJackpotTag: [
    "p1_content_tag",
    "p2_content_tag",
    "p3_content_tag",
    "p4_content_tag",
    "p4b_content_tag",
    "p4c_content_tag",
    "p5_content_tag",
    "p6_content_tag",
    "p9_content_tag",
    'p10_content_tag',
    "p8_content01_tag",
    "p8_content02_tag",
    "p8_content03_tag"
  ],
  historyContent: ['Date', 'Time', 'Obstacle\nDirection', 'Round\nSelection', 'Stake', 'Before\nBalance', 'After\nBalance', 'Win\nAmount', 'Status', 'Prize\nUpgrade']
};

const instances = {
  BetPanel: null,
  SpinButton: null,
  MenuPopUp: null,
  RoundPanel: null,
  Obstacles: null,
  WinsScreen: null,
  PopUpMessage: null,
  Meter: null,
  NetworkLoader: null,
  JackpotPanel: null,
  bulbMeter: null
};

const bgAnimations = [
  "bg_1_clouds_loop",
  "bg_2_clouds_loop",
  "bg_3_clouds_loop",
];
const bgAnimationsIn = [
  "bg_1_clouds_in",
  "bg_2_clouds_in",
  "bg_3_clouds_in",
];
const bgAnimationsOut = [
  "bg_1_clouds_out",
  "bg_2_clouds_out",
  "bg_3_clouds_out",
];
let currentBgAnimation = 0;


function createAppUI(pixiStates) {
  if (tuktukDemoState.isDemo) globalData.showAutoAndTurbo = true;
  setupContainers();
  setupGameScreen();

  setupLayout();
  setupCoins()
  setupLoadingScreen();
  uiCreated = true;

  resetPixiGame(pixiApp.app.screen.width, pixiApp.app.screen.height);

  checkForPendingGame();
  updateBalance();
  updateTotalBet();
  // demoSpine();
  playEngineStart();

  globalData.gameLoaded = true;
  resizeGameUI();
  // console.log(pixiStates)
  globalData.pixiStates = pixiStates;
  // instances.Meter.createMeterContent();
  // tuktukDemoState.isDemo = true;
}


function setSessionExpired() {
  if (!globalData.pixiStates) return;
  globalData.pixiStates.setSessionExpired(true)
}
// function demoSpine() {
//   const demoEjeep = new Spine(
//     PIXI.Assets.get("eJeepney").spineData
//   );
//   demoEjeep.scale.set(1);
//   demoEjeep.y = config.logicalHeight / 2;
//   demoEjeep.x = config.logicalWidth / 2;
//   demoEjeep.state.setAnimation(0, "front_estatic_looking left and right", true);
//   gameAssets.gameScreen.addChild(demoEjeep);

//   const demoEjeepT = new Spine(
//     PIXI.Assets.get("turboJeepneySpine").spineData
//   );
//   demoEjeepT.scale.set(1);
//   demoEjeepT.y = config.logicalHeight / 2;
//   demoEjeepT.x = config.logicalWidth * 0.75;
//   demoEjeepT.state.setAnimation(0, "front_turbo1", true);
//   gameAssets.gameScreen.addChild(demoEjeepT);
// }
function demoWin(winType) {
  globalData.winType = winType;
  globalData.roundWinnings = 10000;
  instances.WinsScreen.showWin();
}


const setFrontAnimationOn = (jeepney, animation = "front") => {
  jeepney.state.timeScale = 1;
  jeepney.state.setAnimation(0, animation, true)
}

function handleGameState(currentGameState = globalData.currentGameState, flag = true) {
  switch (currentGameState) {
    case "idle":
      setTurboVisiblity(0, true);
      setAutoVisiblity(0, true);
      autoGraphic.interactive = true;
      turboGraphic.interactive = true;
      updateTotalBet();
      instances.SpinButton.enableButton();
      instances.BetPanel.enablePanel();
      instances.RoundPanel.enablePanel();
      instances.SpinButton.enablePlayButton();
      instances.SpinButton.roundText.visible = false;
      arrowVisibility(false);
      updateGameSpeed(0.4);
      globalData.currentMeterHeight = 0;
      globalData.currentRound = 0;
      console.log("tuk-tuk-game-game");

      instances.Meter.createMeterContent();
      if (globalData.autoplay) {
        if (globalData.balance > globalData.totalBet) {
          instances.SpinButton.onClick();
        }
        else {
          ShowInsufficientBalancePopup();
          globalData.autoplay = false;
          globalData.turbo = 0;
          gameAssets.autoplayEnabled.visible = false;
          gameAssets.turboEnabled.visible = false;

          if (gameAssets.turboJeepney.visible) {
            gameAssets.transition.visible = true
            gameAssets.turboJeepney.visible = false;
            gameAssets.transition.state.setAnimation(0, "front_turbo2_off_to_tuktuk", false).listener = {
              complete: () => {
                setTimeout(() => {
                  gameAssets.jeepney.state.setAnimation(0, "tuktuk_front", true);
                  gameAssets.jeepney.state.timeScale = 1;

                  gameAssets.transition.visible = false
                  gameAssets.jeepney.visible = true;
                }, 0);
              }
            }
          } else if (gameAssets.autoJeepney.visible) {
            gameAssets.autoJeepney.visible = false;
            gameAssets.jeepney.visible = true;
            gameAssets.jeepney.state.timeScale = 1;
            gameAssets.jeepney.state.setAnimation(0, "tuktuk_front", true);
          }
        }
      } else {
        tweenFadeAppear(gameAssets.startTextContainer, true);
      }
      break;
    case "roundStart":
      if (!globalData.autoplay) {
        gameAssets.menubarButton.tint = 0xffffff
        gameAssets.menubarButton.interactive = true
      }
      instances.RoundPanel.betPanel.visible = false;
      instances.BetPanel.betPanel.visible = false;
      disablePanels();
      instances.SpinButton.roundText.visible = true;
      arrowVisibility(true);
      updateGameSpeed();
      instances.SpinButton.disableButton();
      instances.SpinButton.updateRoundText();
      // if (globalData.autoplay) {
      //   if (globalData.turbo) {          
      //     gameAssets.speedLinesFx.visible = true
      //     if(gameAssets.jeepney.visible) gameAssets.normalJeepCompleted = true;
      //     if (!gameAssets.turboJeepney.visible) {
      //       gameAssets.jeepney.visible = false;
      //       gameAssets.autoJeepney.visible = false;
      //       gameAssets.turboJeepney.visible = true;
      //       gameAssets.turboJeepney.state.setAnimation(0, 'front_turbo2_on', false);
      //       gameAssets.turboJeepney.state.addAnimation(0, 'front_turbo2', true, 0);
      //     }
      //     autoplayRound();
      //   } else {      

      //     gameAssets.autoJeepney.visible = false;
      //     gameAssets.jeepney.visible = false;
      //     if (gameAssets.turboJeepney.visible) {

      //       gameAssets.turboJeepney.state.setAnimation(0, "front_turbo2_off", false).listener = {
      //         complete: () => {

      //           gameAssets.turboJeepney.visible = false;                  
      //           gameAssets.autoJeepney.visible = true;
      //           gameAssets.autoJeepney.state.timeScale = 1;
      //           gameAssets.autoJeepney.state.setAnimation(0, "front", true)
      //           gameAssets.turboCompleted = true;

      //           if(globalData.autoplay){
      //             autoplayRound()
      //           }
      //         }
      //       };
      //     } else {
      //       gameAssets.autoJeepney.visible = true;
      //       gameAssets.autoJeepney.state.timeScale = 1;
      //       gameAssets.autoJeepney.state.setAnimation(0, "front", true);
      //       autoplayRound();
      //     }
      //   }
      // } else {
      //   gameAssets.speedLinesFx.visible = false;
      //   gameAssets.autoJeepney.visible = false;
      //   if (gameAssets.turboJeepney.visible) {
      //     setTurboJeepneyOff(gameAssets.jeepney, "front", 1);
      //   } else {
      //     gameAssets.jeepney.visible = true;
      //     gameAssets.jeepney.state.timeScale = 1;
      //     gameAssets.jeepney.state.setAnimation(0, "tuktuk_front", true);
      //     gameAssets.normalJeepCompleted = true;
      //   }
      // }
      if (globalData.autoplay) {

        if (globalData.turbo) {
          gameAssets.speedLinesFx.visible = true
          if (gameAssets.turboJeepney.visible) {
            autoplayRound("turbo");
          }
          else if (!gameAssets.autoJeepComplete && globalData.turbo) {
            gameAssets.autoJeepney.visible = false;
            gameAssets.turboJeepney.visible = true;
            gameAssets.transition.visible = true
            gameAssets.transition.state.setAnimation(0, 'front_turbo2_on', false).listener = {
              complete: () => {
                setTimeout(() => {

                  //     showFrontJeepney();
                  gameAssets.turboJeepney.state.setAnimation(0, 'front_turbo2', true);
                  gameAssets.transition.visible = false
                  gameAssets.autoJeepComplete = true;
                  autoplayRound("turbo");
                }, 0);
              }
            }
          }
          else {
            gameAssets.jeepney.visible = false;
            gameAssets.turboJeepney.visible = true;
            gameAssets.transition.visible = true
            gameAssets.transition.state.setAnimation(0, 'front_turbo2_on', false).listener = {
              complete: () => {
                setTimeout(() => {
                  //     showFrontJeepney();
                  gameAssets.turboJeepney.state.setAnimation(0, 'front_turbo2', true);
                  gameAssets.transition.visible = false
                  gameAssets.jeepComplete = true;
                  autoplayRound("turbo");
                }, 0);
              }
            }
          }
        }
        else {
          gameAssets.speedLinesFx.visible = false;
          if (!gameAssets.autoJeepComplete) {
            autoplayRound("auto");
          }
          else if (!gameAssets.turboJeepComplete && globalData.autoplay) {
            gameAssets.transition.visible = true
            gameAssets.turboJeepney.visible = false;
            gameAssets.transition.state.setAnimation(0, 'front_turbo2_off', false).listener = {
              complete: () => {
                setTimeout(() => {
                  gameAssets.autoJeepney.state.setAnimation(0, 'front', true);
                  gameAssets.autoJeepney.state.timeScale = 1;
                  gameAssets.transition.visible = false
                  gameAssets.autoJeepney.visible = true;
                  gameAssets.turboJeepComplete = true;
                  autoplayRound("auto");

                }, 0);
              }
            }
          }
          else {
            gameAssets.jeepney.visible = false;
            gameAssets.autoJeepney.visible = true;
            gameAssets.autoJeepney.state.timeScale = 1;
            gameAssets.autoJeepney.state.setAnimation(0, "front", true);
            gameAssets.jeepComplete = true;
            autoplayRound("auto")
          }
        }
      }
      else {
        gameAssets.speedLinesFx.visible = false;
        if (!gameAssets.autoJeepComplete) {
          gameAssets.autoJeepney.visible = false;
          gameAssets.autoJeepComplete = true;
          gameAssets.jeepney.visible = true;
          gameAssets.jeepney.state.timeScale = 1;
          gameAssets.jeepney.state.setAnimation(0, "tuktuk_front", true)
        }
        else if (!gameAssets.turboJeepComplete) {
          gameAssets.transition.visible = true
          gameAssets.turboJeepney.visible = false;
          gameAssets.transition.state.setAnimation(0, 'front_turbo2_off_to_tuktuk', false).listener = {
            complete: () => {
              gameAssets.jeepney.state.timeScale = 1;
              gameAssets.jeepney.state.setAnimation(0, "tuktuk_front", true)
              gameAssets.transition.visible = false
              gameAssets.turboJeepComplete = true;
              gameAssets.jeepney.visible = true;
            }
          }
        } else {
          gameAssets.jeepComplete = true;
        }
        if (flag) {
          gameAssets.timer.visible = true
          gameAssets.timerTween.push(instances.SpinButton.startCircularTimer(gameAssets.timer))
        }
      }
      break;
    case "roundContinue":
      if (currentBgAnimation >= 2) {
        currentBgAnimation = 0;
        gameAssets.background.state.setAnimation(0, bgAnimationsOut[2], false);
        gameAssets.background.state.timeScale = 6;
      } else {
        currentBgAnimation++;
        gameAssets.background.state.setAnimation(
          0,
          bgAnimationsOut[currentBgAnimation - 1],
          false
        );
        gameAssets.background.state.timeScale = 6;
      }
      setTimeout(() => {
        gameAssets.background.state.setAnimation(
          0,
          bgAnimationsIn[currentBgAnimation],
          false
        );
        gameAssets.background.state.timeScale = 6;
        setTimeout(() => {
          gameAssets.background.state.setAnimation(
            0,
            bgAnimations[currentBgAnimation],
            true
          );
          gameAssets.background.state.timeScale = 5;
        }, 1000);
      }, 1000);

      instances.SpinButton.disableButton();
      checkJeepnyCrash();
      arrowVisibility(false);
      break;
    case "roundEnd":
      gameAssets.background.state.setAnimation(0, 'bg_1_clouds_out', false)
      //  globalData.totalWin += globalData.currentRoundWin
      if (globalData.nearMiss) {
        setTimeout(() => {
          gameAssets.background.state.setAnimation(0, 'bg_1_clouds_in', false)
          // processSpinResult();
          centerJeepney();
        }, 700);
      } else {
        setTimeout(() => {
          gameAssets.background.state.setAnimation(0, 'bg_1_clouds_in', false)
          // processSpinResult();
          centerJeepney();
        }, turboData.roundEndTimeout[globalData.turbo]);
      }
      break;
    case "result":
      autoGraphic.interactive = false;
      turboGraphic.interactive = false;
      gameAssets.jeepComplete = true;
      if (gameAssets.timerTween.length) {
        gameAssets.timerTween.forEach(tween => tween.kill());
        gameAssets.timerTween.length = [];
      }
      gameAssets.timer.visible = false;
      if (!globalData.autoplay) {
        gameAssets.menubarButton.tint = 0xffffff
        gameAssets.menubarButton.interactive = true

        gameAssets.speedLinesFx.visible = false
        if (gameAssets.autoJeepney.visible) {
          gameAssets.autoJeepney.visible = false;
          gameAssets.autoJeepComplete = true;
          gameAssets.jeepney.visible = true;
          gameAssets.jeepney.state.timeScale = 1;
          gameAssets.jeepney.state.setAnimation(0, "tuktuk_front", true);
        } else {
          gameAssets.turboJeepney.state.timeScale = 1;
          gameAssets.transition.state.setAnimation(0, "front_turbo2_off", false).listener = {
            complete: () => {
              gameAssets.jeepney.state.timeScale = 1;
              gameAssets.jeepney.state.setAnimation(0, "tuktuk_front", true);
              gameAssets.turboJeepney.visible = false;
              gameAssets.jeepney.visible = true;
              gameAssets.turboJeepComplete = true;
            }
          }
        }
      }
      setTurboVisiblity(0.8, false);
      setAutoVisiblity(0.8, false);
      if (globalData.roundWinnings > 0) {
        if (globalData.prizeUpgrade) {
          setTimeout(() => {
            instances.WinsScreen.showWin();
          }, 5500);
        }
        else {
          instances.WinsScreen.showWin();
        }
      } else if (globalData.roundWinnings <= 0) {
        if (globalData.jackpotMinorWin || globalData.jackpotMajorWin || globalData.jackpotGrandWin) {
          rebootButton();
          instances.WinsScreen.minorJackpotSpine.addChild(instances.WinsScreen.minorJackpotText);
          instances.WinsScreen.majorJackpotSpine.addChild(instances.WinsScreen.majorJackpotText);
          instances.WinsScreen.grandJackpotSpine.addChild(instances.WinsScreen.grandJackpotText);

          instances.WinsScreen.minorJackpotText.zIndex = 500;
          instances.WinsScreen.majorJackpotText.zIndex = 500;
          instances.WinsScreen.grandJackpotText.zIndex = 500;

          instances.WinsScreen.minorJackpotSpine.sortableChildren = true;
          instances.WinsScreen.majorJackpotSpine.sortableChildren = true;
          instances.WinsScreen.grandJackpotSpine.sortableChildren = true;
          instances.WinsScreen.jackpot()
        } else {
          instances.WinsScreen.showLose();
        }
      }
      break;
  }
}

function restartGame() {
  // globalData.balance += globalData.roundWinnings;
  // globalData.balance += globalData.jackpotWin;
  if (globalData.jackpot) resetJackpotPanel();
  globalData.prizeUpgrade = false;
  globalData.winComplete = false;
  globalData.showAmount = false;
  globalData.flag = false
  globalData.jackpotWin = 0
  globalData.roundWinnings = 0;
  globalData.jackpot = false;
  globalData.currentGameState = gameStates.IDLE;
  instances.WinsScreen.backgroundBlur.visible = false;
  gameAssets.menubarButton.tint = 0xffffff
  gameAssets.menubarButton.interactive = true
  handleGameState(globalData.currentGameState);
}

function autoplayRound(jeep) {
  if (gameAssets.autoplayInprogress) return;
  gameAssets.timer.visible = false;
  if (gameAssets.timerTween.length) {
    gameAssets.timerTween.forEach(tween => tween.kill());
    gameAssets.timerTween.length = [];
  }
  gameAssets.menubarButton.tint = 0x606060
  gameAssets.menubarButton.interactive = false

  if (jeep === "auto")
    gameAssets.autoJeepComplete = false;
  else
    gameAssets.turboJeepComplete = false;

  gameAssets.autoplayInprogress = true;
  globalData.currentRound += 1;
  setTimeout(() => {
    const jeepneyLane = instances.Obstacles.generateRandomNumber(0, 1);
    if (globalData.currentGameState == gameStates.ROUND_START) {
      // gameAssets.arrowLeftEnabled.interactive = false;
      // gameAssets.arrowRightEnabled.interactive = false;
      if (jeepneyLane) {
        globalData.jeepneyLane = "R";
        gameAssets.arrowRightHover.visible = true;
        // playJeepneyRight()
      } else {
        globalData.jeepneyLane = "L";
        gameAssets.arrowLeftHover.visible = true;
        // playJeepneyLeft()
      }
      // instances.SpinButton.updateRoundText();
      setTimeout(() => {
        arrowVisibility(false);
        if (globalData.jeepneyLane === "R") {

          if (gameAssets.autoJeepney.visible) {
            gameAssets.autoJeepney.state.timeScale =
              turboData.jeepTurnSpeed[globalData.turbo];
            gameAssets.autoJeepney.state.setAnimation(0, "front_to_R_side", false);
          } else {

            gameAssets.turboJeepney.state.timeScale =
              turboData.jeepTurnSpeed[globalData.turbo];
            gameAssets.turboJeepney.state.setAnimation(0, "front_turbo2_to_R_side", false);

          }
          setTimeout(() => {

            if (gameAssets.autoJeepney.visible) {
              gameAssets.autoJeepney.state.timeScale = 1;
              gameAssets.autoJeepney.state.setAnimation(0, "R_side", true);
            } else {
              //  showRightJeepney();
              gameAssets.turboJeepney.state.timeScale = 1;
              gameAssets.turboJeepney.state.setAnimation(0, "R_side_turbo2", true);

            }

            playJeepneyRight();
            processSpinResult();
          }, turboData.timeOutDataJeepTurn[globalData.turbo]);
        } else if (globalData.jeepneyLane === "L") {
          if (gameAssets.autoJeepney.visible) {


            gameAssets.autoJeepney.state.timeScale =
              turboData.jeepTurnSpeed[globalData.turbo];
            gameAssets.autoJeepney.state.setAnimation(0, "front_to_L_side", false);
          } else {

            gameAssets.turboJeepney.state.timeScale =
              turboData.jeepTurnSpeed[globalData.turbo];
            gameAssets.turboJeepney.state.setAnimation(0, "front_turbo2_to_L_side", false);

          }
          setTimeout(() => {
            if (gameAssets.autoJeepney.visible) {
              gameAssets.autoJeepney.state.timeScale = 1;
              gameAssets.autoJeepney.state.setAnimation(0, "L_side", true);
            } else {
              //  showLeftJeepney();
              gameAssets.turboJeepney.state.timeScale = 1;
              gameAssets.turboJeepney.state.setAnimation(0, "L_side_turbo2", true);
            }
            playJeepneyLeft();
            processSpinResult();
          }, turboData.timeOutDataJeepTurn[globalData.turbo]);
        }
        gameAssets.arrowRightHover.visible = false;
        gameAssets.arrowLeftHover.visible = false;
        // gameAssets.arrowLeftEnabled.interactive = true;
        // gameAssets.arrowRightEnabled.interactive = true;
      }, 500);
    }
  }, 300);
}
// function showFrontJeepney() {
//   gameAssets.turboJeepney.visible = false
//   gameAssets.turboJeepney.visible = false
//   gameAssets.turboJeepney.visible = true
// }

// function showLeftJeepney() {
//   gameAssets.turboJeepney.visible = false
//   gameAssets.turboJeepney.visible = false
//   gameAssets.turboJeepney.visible = true
// }

// function showRightJeepney() {
//   gameAssets.turboJeepney.visible = false
//   gameAssets.turboJeepney.visible = false
//   gameAssets.turboJeepney.visible = true
// }

function disablePanels() {
  if (!instances.BetPanel.enabled) return;
  // deductBalance();
  instances.BetPanel.disablePanel();
  instances.RoundPanel.disablePanel();
}

function checkJeepnyCrash() {
  instances.Obstacles.generateObstacle(globalData.obstacleLane);

  globalData.currentRoundLose = instances.Obstacles.checkCrash(
    globalData.obstacleLane
  );
  if (globalData.currentRoundLose) {
    setTimeout(() => {
      instances.Meter.useFuel();
      if (globalData.prizeUpgrade) instances.Meter.moveMeter();
    }, 850);
  } else {
    instances.Meter.moveMeter();
  }
  processSpinResult();
}

// function deductBalance() {
//   globalData.balance -= globalData.totalBet;
//   updateBalance();
// }
function setupGameScreen() {
  const backdrop = new PIXI.Sprite(PIXI.Assets.get("backdrop"));
  backdrop.anchor.set(0.5);
  backdrop.scale.set(10);
  backdrop.x = window.innerWidth / 2;
  backdrop.y = window.innerHeight * 0.5;
  containers.bgContainer.addChild(backdrop);

  const gameMask = new PIXI.Sprite(PIXI.Assets.get("gameScreen"));
  gameMask.anchor.set(0.5);

  gameAssets.gameScreen = new PIXI.Container();

  const mask = new PIXI.Graphics();
  mask.beginFill(0xffffff);
  mask.drawRect(0, -1800, config.logicalWidth, config.logicalHeight + 3000);
  mask.endFill();
  gameAssets.gameScreen.addChild(mask);
  gameAssets.gameScreen.mask = mask;

  const sky = new PIXI.Graphics();
  sky.beginFill(0x4ab0e6);
  sky.drawRect(0, -1200, config.logicalWidth, config.logicalHeight + 2500);
  sky.endFill();
  gameAssets.gameScreen.addChild(sky);
  gameAssets.gameScreen.mask = mask;

  const background = new PIXI.Graphics();
  background.beginFill(0x202a44);
  background.drawRect(0, 0, config.logicalWidth, config.logicalHeight);
  background.endFill();
  gameAssets.gameScreen.addChild(background);

  gameAssets.gameScreen2 = new PIXI.Container();
  containers.bgContainer.addChild(gameAssets.gameScreen)
  containers.bgContainer.addChild(gameAssets.gameScreen2)

}

function setupLoadingScreen() {

  gameAssets.loadingScreen = new PIXI.Sprite(PIXI.Assets.get('tuktukIntroBg'))
  gameAssets.loadingScreen.anchor.set(0.5)
  gameAssets.loadingScreen.scale.set(1)
  gameAssets.loadingScreen.x = config.logicalWidth / 2
  gameAssets.loadingScreen.y = config.logicalHeight / 2
  gameAssets.loadingScreen.initialX = gameAssets.loadingScreen.finalX = gameAssets.loadingScreen.x
  gameAssets.loadingScreen.initialY = gameAssets.loadingScreen.finalY = gameAssets.loadingScreen.y

  const logo = new PIXI.Sprite(PIXI.Assets.get('tuktukLogo'))
  logo.anchor.set(0.5)
  logo.scale.set(1.95)
  logo.x = 0
  logo.y = -895

  gameAssets.loadingScreen.addChild(logo)
  gameAssets.gameScreen.addChild(gameAssets.loadingScreen);
  gameAssets.gameScreen.addChild(instances.PopUpMessage.popUpContainer);


  const style = new PIXI.TextStyle({
    dropShadow: true,
    dropShadowBlur: 10,
    dropShadowColor: "#252525",
    dropShadowDistance: 10,
    stroke: "#D75E08",
    strokeThickness: 2,
    fill: "#F9B41E",
    fontFamily: "Arial",
    fontSize: 70,
    fontWeight: "900",
    align: "center",
    fontStyle: "italic",
  });

  gameAssets.clickText = new PIXI.Text("TAP TO START", style);
  gameAssets.clickText.anchor.set(0.5);
  gameAssets.clickText.y = 900
  gameAssets.clickText.text = "CONNECTING..."
  // clickText.visible = false;
  gameAssets.loadingScreen.addChild(gameAssets.clickText);
  gameAssets.loadingScreen.interactive = false
  gameAssets.loadingScreen.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      disableLoadingScreen()

      if (!globalData.gameLanguage) {
        changeBackGroundInteractiveState(false);
        setupDimmer()
        setupPopup()
        setupArrow()
        //   showJackpotPanel();
      }
    }
  })
}

function setupArrow() {
  if (gameAssets.arrow) return;

  gameAssets.arrow = new PIXI.Sprite(PIXI.Assets.get('scrollArrow'));
  gameAssets.arrow.anchor.set(0.5);
  gameAssets.arrow.scale.set(2);
  gameAssets.arrow.y = 725;
  gameAssets.arrow.interactive = true;
  gameAssets.arrow.cursor = 'pointer'
  gameAssets.arrow.visible = false;
  gameAssets.arrow.zIndex = 5000;

  containers.pageContainer.addChild(gameAssets.arrow);

  gameAssets.arrow.on('pointerdown', () => {
    gameAssets.arrow.visible = false;

    if (gameAssets.currentPage == 2) {
      globalData.ftuePrizeScroll = true;
    } else {
      globalData.ftueIsScroll = true;
    }
  });

  gsap.timeline({ repeat: -1, yoyo: true })
    .to(gameAssets.arrow, {
      pixi: {
        scale: 2.6
      },
      duration: 0.3,
      ease: "power1.inOut",
    });
}

function ftueScroll(delta) {
  gameAssets.page[gameAssets.page.length - 1].y = gameAssets.page[gameAssets.page.length - 1].y - delta * 3;

  if (gameAssets.page[gameAssets.page.length - 1].y < gameAssets.scrollPos) {
    globalData.ftueIsScroll = false;
  }
}

function ftuePrizeScroll(delta) {
  gameAssets.page[2].y = gameAssets.page[2].y - delta * 3;

  if (gameAssets.page[2].y < gameAssets.prizePos) {
    globalData.ftuePrizeScroll = false;
  }
}

function showTutorial(lang) {
  gameAssets.popUp.visible = false;
  gameAssets.dimmer.visible = false;
  gameAssets.engLang.interactive = false;
  gameAssets.tagLang.interactive = false;
  setUpMask()

  if (lang == "English") {
    gameAssets.prizePosition = -680;
    rulesPageContant(
      globalData.isJackpotActive ? gameAssets.withJackpotEng : gameAssets.withoutJackpotEng
    );
  } else {
    gameAssets.prizePosition = -578;
    rulesPageContantTag(globalData.isJackpotActive ? gameAssets.withJackpotTag : gameAssets.withoutJackpotTag)
  }
  pagination();
}

function setupPopup() {
  const text = new PIXI.Text("Languages", {
    fontFamily: "Arial",
    fontSize: 55,
    fill: ["#ffffff", "#ffcc00"],
    fontWeight: "bold",
    stroke: "#000000",
    strokeThickness: 4,
    dropShadow: true,
    dropShadowColor: "#000000",
    dropShadowBlur: 6,
    dropShadowAngle: Math.PI / 6,
    dropShadowDistance: 4,
    align: "center"
  });

  text.anchor.set(0.5);
  text.y = -180
  gameAssets.popUp = new PIXI.Sprite(PIXI.Assets.get('pop_up_board'));
  gameAssets.popUp.anchor.set(0.5);
  gameAssets.popUp.scale.set(1.85)
  gameAssets.popUp.x = config.logicalWidth * 0.5
  gameAssets.popUp.y = config.logicalHeight * 0.45

  gameAssets.engLang = new PIXI.Sprite(PIXI.Assets.get('lang_english'));
  gameAssets.engLang.anchor.set(0.5);
  gameAssets.engLang.y = -60;
  gameAssets.engLang.scale.set(1);
  gameAssets.engLang.interactive = true;
  gameAssets.engLang.cursor = 'pointer'

  gameAssets.tagLang = new PIXI.Sprite(PIXI.Assets.get('lang_tagalog'));
  gameAssets.tagLang.anchor.set(0.5);
  gameAssets.tagLang.y = gameAssets.engLang.y + 190;
  gameAssets.tagLang.scale.set(1);
  gameAssets.tagLang.interactive = true;
  gameAssets.tagLang.cursor = 'pointer'

  gameAssets.tagLang.on("pointerdown", () => {
    gameAssets.tagLang.scale.set(0.95)
  })

  gameAssets.tagLang.on("pointerup", () => {
    gameAssets.tagLang.scale.set(1)
    gameAssets.prizePos = -650
    gameAssets.scrollPos = -2265;
    showTutorial("Tagalog")
    setLanguage("tl")
    globalData.gameLanguage = 'tl'
    instances.MenuPopUp.setupBlueButtons(0, -85)
  })

  gameAssets.engLang.on("pointerdown", () => {
    gameAssets.engLang.scale.set(0.95)
  })

  gameAssets.engLang.on("pointerup", () => {
    gameAssets.engLang.scale.set(1)
    gameAssets.prizePos = -700
    gameAssets.scrollPos = -2270;
    showTutorial("English")
    setLanguage("en")
    globalData.gameLanguage = 'en'
    instances.MenuPopUp.setupBlueButtons(0, -85)
  })

  gameAssets.engLang.on("pointerover", () => {
    gameAssets.engLang.scale.set(1.1);
    gameAssets.engLang.tint = 0xcccccc;
  });

  gameAssets.engLang.on("pointerout", () => {
    gameAssets.engLang.scale.set(1);
    gameAssets.engLang.tint = 0xffffff;
  });

  gameAssets.tagLang.on("pointerover", () => {
    gameAssets.tagLang.scale.set(1.1);
    gameAssets.tagLang.tint = 0xcccccc;
  });

  gameAssets.tagLang.on("pointerout", () => {
    gameAssets.tagLang.scale.set(1);
    gameAssets.tagLang.tint = 0xffffff;
  });

  gameAssets.popUp.addChild(text, gameAssets.engLang, gameAssets.tagLang)
  gameAssets.gameScreen.addChild(gameAssets.popUp)
}


function setupDimmer() {
  gameAssets.dimmer = new PIXI.Sprite(PIXI.Assets.get("dimmer"));
  gameAssets.dimmer.anchor.set(0.5);
  gameAssets.dimmer.tint = 0;
  gameAssets.dimmer.x = 0
  gameAssets.dimmer.y = 400
  gameAssets.dimmer.scale.set(5)
  gameAssets.dimmer.alpha = 0.90

  gameAssets.gameScreen.addChild(gameAssets.dimmer);
}

function changeBackGroundInteractiveState(isInteractive) {
  instances.BetPanel.plusBtnHitGraphic.interactive = isInteractive;
  instances.BetPanel.minusBtnHitGraphic.interactive = isInteractive;
  instances.BetPanel.betIcon.interactive = isInteractive;
  instances.RoundPanel.plusBtnHitGraphic.interactive = isInteractive;
  instances.RoundPanel.minusBtnHitGraphic.interactive = isInteractive;
  instances.RoundPanel.roundIcon.interactive = isInteractive;
  instances.SpinButton.hitGraphics.interactive = isInteractive;
  autoGraphic.interactive = isInteractive;
  turboGraphic.interactive = isInteractive;
  gameAssets.demoButton.interactive = isInteractive;
  gameAssets.menubarButton.interactive = isInteractive;
}

function pendingGameUpdate(multiplier = 0) {
  // gameAssets.loadingScreen.children[0].text = "TAP TO START"
  const style = new PIXI.TextStyle({
    dropShadow: true,
    dropShadowBlur: 10,
    dropShadowColor: "#252525",
    dropShadowDistance: 10,
    stroke: "#D75E08",
    strokeThickness: 2,
    fill: "#F9B41E",
    fontFamily: "Arial",
    fontSize: 70,
    fontWeight: "900",
    align: "center",
    fontStyle: "italic",
  });

  gameAssets.clickText.visible = false;
  const clickText = new PIXI.Text("TAP TO START", style);
  clickText.anchor.set(0.5);
  clickText.y = 900
  gameAssets.loadingScreen.addChild(clickText);
  gameAssets.loadingScreen.interactive = true;
  resumeMeter(multiplier);
}

function resumeMeter(multiplier = 0) {
  instances.Meter.createMeterContent();
  for (let i = 0; i < globalData.numOfRoundsWon; i++) {
    instances.Meter.moveMeter(false);
  }
  instances.Meter.BulbMeter.fillFuel(instances.Meter.multipliers[globalData.totalRounds].length - (globalData.currentRound - globalData.numOfRoundsWon))
}
function formatBalance(balance, toFixed = 2) {
  return Number(balance)
    .toFixed(toFixed)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
export function disableLoadingScreen() {
  // gameAssets.loadingScreen.visible = false;
  tweenFadeAppear(gameAssets.loadingScreen, false);
  playEngineLoop();
  playMainBg();
  gsap.delayedCall(0.15, () => {
    tweenFadeAppear(gameAssets.gameUI, true)
  });

  if (globalData.isJackpotActive && globalData.gameLanguage) {
    showJackpotPanel()
    if (!globalData.jackpotMinorWin) showMinorJackpotWin(globalData.minorCurrentJackpotValue)
    if (!globalData.jackpotMajorWin) showMajorJackpotWin(globalData.majorCurrentJackpotValue)
    if (!globalData.jackpotGrandWin) showGrandJackpotWin(globalData.grandCurrentJackpotValue)
  } else {
    hideJackpotPanel();
  }
  gameAssets.menubarButton.visible = true;

  if (globalData.currentGameState == gameStates.ROUND_START) {
    gameAssets.timer.visible = true;
    gameAssets.timerTween.push(instances.SpinButton.startCircularTimer(gameAssets.timer))
  }

  // gameAssets.gameUI.visible = true;
}
function setupLayout() {
  //GAME BACKGROUN AND ENVIRONMENT SETUP
  gameAssets.sky = new PIXI.Sprite(PIXI.Assets.get("sky"));
  gameAssets.sky.anchor.set(0.5);
  gameAssets.sky.scale.set(1.05);
  gameAssets.sky.x = config.logicalWidth / 2;
  gameAssets.sky.y = config.logicalHeight / 2 - 900;

  // gameAssets.background = new SpineOld(
  //   PIXI.Assets.get("backgroundSpine").spineData
  // );
  gameAssets.background = Spine.from({ skeleton: "backgroundSpine", atlas: "backgroundAtlas" });

  gameAssets.background.scale.set(1);
  gameAssets.background.x = config.logicalWidth / 2;
  gameAssets.background.y = config.logicalHeight / 2 + 280;
  gameAssets.background.state.setAnimation(0, "bg_1_clouds_in", true);
  gameAssets.background.state.timeScale = globalData.gameSpeed;

  // gameAssets.midground = new SpineOld(
  //   PIXI.Assets.get("middlegroundSpine").spineData
  // );
  gameAssets.midground = Spine.from({ skeleton: "middlegroundSpine", atlas: "middlegroundAtlas" });

  gameAssets.midground.scale.set(1);
  gameAssets.midground.x = config.logicalWidth / 2;
  gameAssets.midground.y = config.logicalHeight / 2 + 300;
  gameAssets.midground.state.setAnimation(
    0,
    "middleground_windmill_loop",
    true
  );
  gameAssets.midground.state.timeScale = globalData.gameSpeed;

  // gameAssets.foreground = new SpineOld(
  //   PIXI.Assets.get("foregroundSpine").spineData
  // );
  gameAssets.foreground = Spine.from({ skeleton: "foregroundSpine", atlas: "foregroundAtlas" });
  gameAssets.foreground.x = config.logicalWidth / 2;
  gameAssets.foreground.scale.set(1);
  gameAssets.foreground.y = config.logicalHeight / 2 + 450;
  gameAssets.foreground.state.setAnimation(0, "loop", true);
  gameAssets.foreground.state.timeScale = globalData.gameSpeed;
  // console.log("spine foreground jackpot", gameAssets.foreground)
  // gameAssets.ambientBackground = new SpineOld(
  //   PIXI.Assets.get("ambientBackground").spineData
  // );
  gameAssets.ambientBackground = Spine.from({ skeleton: "ambientBackground", atlas: "ambientBackgroundAtlas" });

  gameAssets.ambientBackground.x = config.logicalWidth * 0.4;
  gameAssets.ambientBackground.y = config.logicalHeight * 0.75;
  gameAssets.ambientBackground.scale.set(1.5);
  gameAssets.ambientBackground.state.setAnimation(
    0,
    "hotair balloon_animation",
    true
  );
  gameAssets.ambientBackground.state.timeScale = 1;

  // gameAssets.birds = new SpineOld(PIXI.Assets.get("ambientBackground").spineData);
  gameAssets.birds = Spine.from({ skeleton: "ambientBackground", atlas: "ambientBackgroundAtlas" });

  gameAssets.birds.x = config.logicalWidth * 1;
  gameAssets.birds.y = config.logicalHeight * 0.075;
  gameAssets.birds.scale.set(0.9);
  gameAssets.birds.state.setAnimation(0, "bird/birds_set_far", true);
  gameAssets.birds.state.timeScale = 1;
  gameAssets.birds.alpha = 1;

  gameAssets.gameScreen.addChild(
    gameAssets.sky,
    gameAssets.background,
    gameAssets.birds,
    gameAssets.midground,
    gameAssets.ambientBackground,
    gameAssets.foreground,
    gameAssets.birds
  );
  // setupCharacter();

  // const bitmapText = new PIXI.BitmapText('Agnivesh', {
  //   fontName: 'normal-font',
  //   fontSize: 32,
  //   letterSpacing : -50
  // });
  // bitmapText.anchor.set(0.5);
  // bitmapText.x = config.logicalWidth / 2;
  // bitmapText.y = config.logicalHeight / 2;

  // gameAssets.gameScreen.addChild(bitmapText);
  instances.Obstacles = new obstacles();
  gameAssets.gameScreen.addChild(instances.Obstacles.potholeContainer);
  setupJeepney();
  setupAutoAndTurboJeepney()
  setupAmbientLeaves();
  setupGameUI();
}

function setupAmbientLeaves() {
  // leavesSpine = new SpineOld(PIXI.Assets.get("leavesSpine").spineData);
  leavesSpine = Spine.from({ skeleton: "leavesSpine", atlas: "leavesAtlas" });

  leavesSpine.scale.set(1.1);
  leavesSpine.x = config.logicalWidth * 0.5;
  leavesSpine.y = config.logicalHeight * 0.55;
  leavesSpine.state.setAnimation(0, "leaves_yellow", true);
  gameAssets.gameScreen.addChild(leavesSpine);

}
export function updateGameSpeed(gameSpeed = false, flag = false) {
  globalData.gameSpeed = gameSpeed;
  if (gameSpeed) {
    gameAssets.foreground.state.timeScale = globalData.gameSpeed * turboData.gameSpeed[globalData.turbo];
    gameAssets.midground.state.timeScale = globalData.gameSpeed * turboData.gameSpeed[globalData.turbo];
    gameAssets.background.state.timeScale = globalData.gameSpeed * turboData.gameSpeed[globalData.turbo];
  } else {
    gameAssets.foreground.state.timeScale =
      globalData.currentRound / globalData.totalRounds + 0.5 * turboData.gameSpeed[globalData.turbo];
    gameAssets.midground.state.timeScale =
      globalData.currentRound / globalData.totalRounds + 0.5 * turboData.gameSpeed[globalData.turbo];
    gameAssets.background.state.timeScale =
      globalData.currentRound / globalData.totalRounds + 0.5 * turboData.gameSpeed[globalData.turbo];
  }
  if (flag) {
    gameAssets.ambientBackground.state.timeScale = 1;
    gameAssets.birds.visible = true;
    instances.Meter.meterSpeed = 4;
    leavesSpine.state.timeScale = 1;
  }
}
function getSpineTextureMemory(spineObject, label = "") {
  if (!spineObject || !spineObject.spineData || !spineObject.spineData.atlas) {
    // console.warn("Invalid Spine object.");
    return 0;
  }

  let textureSize = spineObject.spineData.atlas.pages.reduce((total, page) => {
    let baseTexture = PIXI.BaseTexture.from(page.name);
    return total + (baseTexture.width * baseTexture.height * 4) / (1024 * 1024); // Convert to MB
  }, 0);

}

// Example usage:

function setupJeepney() {
  // gameAssets.jeepney = new SpineOld(PIXI.Assets.get("jeepneySpine").spineData);
  gameAssets.jeepney = Spine.from({ skeleton: "tuktukSpine", atlas: "tuktukAtlas" });

  gameAssets.jeepney.x = config.logicalWidth * 0.5;
  gameAssets.jeepney.y = config.logicalHeight * 0.6;
  gameAssets.jeepney.scale.set(1);
  gameAssets.jeepney.state.setAnimation(0, "tuktuk_front", true);
  gameAssets.jeepney.state.timeScale = 1;
  gameAssets.gameScreen.addChild(gameAssets.jeepney);

  // gameAssets.chicken = new SpineOld(PIXI.Assets.get("jeepneySpine").spineData);
}

function setupAutoAndTurboJeepney() {

  // gameAssets.autoJeepney = new SpineOld(PIXI.Assets.get('jeepneyautoSpine').spineData);
  gameAssets.autoJeepney = Spine.from({ skeleton: "tuktukSpine", atlas: "tuktukAtlas" });

  gameAssets.autoJeepney.x = config.logicalWidth * 0.5;
  gameAssets.autoJeepney.y = config.logicalHeight * 0.6;
  gameAssets.autoJeepney.scale.set(1);

  gameAssets.autoJeepney.visible = false;

  getSpineTextureMemory(gameAssets.autoJeepney, "autoJeepney")

  gameAssets.gameScreen.addChild(gameAssets.autoJeepney);

  // gameAssets.autoChicken = new Spine(PIXI.Assets.get("jeepneyautoSpine").spineData);
  // gameAssets.autoChicken.scale.set(1);

  // gameAssets.autoChicken.state.timeScale = 1;
  //gameAssets.autoJeepney.addChild(gameAssets.autoChicken);

  // gameAssets.turboJeepney = new SpineOld(PIXI.Assets.get("jeepneyturboSpine").spineData);
  gameAssets.turboJeepney = Spine.from({ skeleton: "tuktukSpine", atlas: "tuktukAtlas" });

  gameAssets.turboJeepney.scale.set(1);
  gameAssets.turboJeepney.x = config.logicalWidth * 0.5;
  gameAssets.turboJeepney.y = config.logicalHeight * 0.6;
  gameAssets.turboJeepney.visible = false;

  gameAssets.turboJeepney.state.setAnimation(0, 'front_turbo2', false)

  getSpineTextureMemory(gameAssets.turboJeepney, "turboJeepney")


  // gameAssets.turboJeepney = new SpineOld(PIXI.Assets.get("jeepneyturboSpineL").spineData);
  //  gameAssets.turboJeepney = Spine.from({ skeleton: "jeepneyturboSpineL", atlas: "jeepneyturboAtlasL" });

  // gameAssets.turboJeepney.scale.set(1);
  // gameAssets.turboJeepney.x = config.logicalWidth * 0.5;
  // gameAssets.turboJeepney.y = config.logicalHeight * 0.6;
  // gameAssets.turboJeepney.visible = false;
  // gameAssets.gameScreen.addChild(gameAssets.turboJeepney);
  // getSpineTextureMemory(gameAssets.turboJeepney, "turboJeepney")

  // // gameAssets.turboJeepney = new SpineOld(PIXI.Assets.get("jeepneyturboSpineR").spineData);
  // gameAssets.turboJeepney = Spine.from({ skeleton: "jeepneyturboSpineR", atlas: "jeepneyturboAtlasR" });

  // gameAssets.turboJeepney.scale.set(1);
  // gameAssets.turboJeepney.x = config.logicalWidth * 0.5;
  // gameAssets.turboJeepney.y = config.logicalHeight * 0.6;
  // gameAssets.turboJeepney.visible = false;
  // gameAssets.gameScreen.addChild(gameAssets.turboJeepney);

  // gameAssets.turboChicken = new Spine(PIXI.Assets.get("jeepneyturboSpine").spineData);;
  // gameAssets.turboChicken.scale.set(1);
  // gameAssets.turboJeepney.addChild(gameAssets.turboChicken)
  gameAssets.gameScreen.addChild(gameAssets.turboJeepney);


  // gameAssets.transition = new SpineOld(PIXI.Assets.get("jeepneytransitionSpine").spineData);
  gameAssets.transition = Spine.from({ skeleton: "tuktukSpine", atlas: "tuktukAtlas" });
  gameAssets.transition.scale.set(1);
  gameAssets.transition.x = config.logicalWidth * 0.5;
  gameAssets.transition.y = config.logicalHeight * 0.6
  gameAssets.gameScreen.addChild(gameAssets.transition)
  gameAssets.transition.state.timeScale = 1.65;
  gameAssets.transition.visible = false


  gameAssets.chicken = Spine.from({ skeleton: "tuktukSpine", atlas: "tuktukAtlas" });

  gameAssets.chicken.scale.set(1);
  // gameAssets.chicken.state.setAnimation(0, 'Chicken_splat', true)
  gameAssets.chicken.state.timeScale = 1;
  gameAssets.chicken.x = config.logicalWidth * 0.5;
  gameAssets.chicken.y = config.logicalHeight * 0.6;
  gameAssets.gameScreen.addChild(gameAssets.chicken);



  setupSpeedLines();

}

function setupSpeedLines() {
  gameAssets.speedLinesFx = Spine.from({ skeleton: "speedFx", atlas: "speedFxAtlas" });
  // gameAssets.speedLinesFx = new Spine(PIXI.Assets.get("speedFx").spineData);
  gameAssets.speedLinesFx.scale.set(1.2);
  gameAssets.speedLinesFx.x = config.logicalWidth * 0.5;
  gameAssets.speedLinesFx.y = config.logicalHeight * 0.47;
  gameAssets.speedLinesFx.visible = false;

  gameAssets.speedLinesFx.state.setAnimation(0, "x1_(50%opacity)", true)

  gameAssets.gameScreen.addChild(gameAssets.speedLinesFx);
}
function centerJeepney() {

  if (globalData.nearMiss) {
    if (globalData.jeepneyLane === "L") {
      if (gameAssets.autoplayInprogress) {
        if (gameAssets.autoJeepney.visible) {
          gameAssets.autoJeepney.state.timeScale =
            turboData.jeepTurnSpeed[globalData.turbo];
          gameAssets.autoJeepney.state.setAnimation(
            0,
            "L_side_to_front_Swerving",
            false
          );
        } else {
          gameAssets.turboJeepney.state.timeScale =
            turboData.jeepTurnSpeed[globalData.turbo];
          gameAssets.turboJeepney.state.setAnimation(
            0,
            "L_side_turbo2_to_front_Swerving",
            false
          );
        }
      } else {
        gameAssets.jeepney.state.timeScale =
          turboData.jeepTurnSpeed[globalData.turbo];
        gameAssets.jeepney.state.setAnimation(
          0,
          "tuktuk_L_side_to_front_Swerving",
          false
        );
      }
      globalData.jeepneyLane = null;
    } else if (globalData.jeepneyLane === "R") {
      if (gameAssets.autoplayInprogress) {
        if (gameAssets.autoJeepney.visible) {
          gameAssets.autoJeepney.state.timeScale =
            turboData.jeepTurnSpeed[globalData.turbo];
          gameAssets.autoJeepney.state.setAnimation(
            0,
            "R_side_to_front_Swerving",
            false
          );
        } else {
          gameAssets.turboJeepney.state.timeScale =
            turboData.jeepTurnSpeed[globalData.turbo];
          gameAssets.turboJeepney.state.setAnimation(
            0,
            "R_side_turbo2_to_front_Swerving",
            false
          );
        }
      } else {
        gameAssets.jeepney.state.timeScale =
          turboData.jeepTurnSpeed[globalData.turbo];
        gameAssets.jeepney.state.setAnimation(
          0,
          "tuktuk_R_side_to_front_Swerving",
          false
        );
      }
      globalData.jeepneyLane = null;
    }
  }
  else {
    if (globalData.jeepneyLane === "L") {
      if (gameAssets.autoplayInprogress) {

        if (gameAssets.turboJeepney.visible) {
          gameAssets.turboJeepney.state.timeScale =
            turboData.jeepTurnSpeed[globalData.turbo];
          gameAssets.turboJeepney.state.setAnimation(0, "L_side_turbo2_to_front", false);
        } else {
          gameAssets.autoJeepney.state.timeScale =
            turboData.jeepTurnSpeed[globalData.turbo];
          gameAssets.autoJeepney.state.setAnimation(0, "L_side_to_front", false);
        }
      } else {
        gameAssets.jeepney.state.timeScale =
          turboData.jeepTurnSpeed[globalData.turbo];
        gameAssets.jeepney.state.setAnimation(0, "tuktuk_L_side_to_front", false);

      }

      globalData.jeepneyLane = null;
    } else if (globalData.jeepneyLane === "R") {
      if (gameAssets.autoplayInprogress) {
        if (gameAssets.turboJeepney.visible) {
          gameAssets.turboJeepney.state.timeScale =
            turboData.jeepTurnSpeed[globalData.turbo];
          gameAssets.turboJeepney.state.setAnimation(0, "R_side_turbo2_to_front", false)
        } else {
          gameAssets.autoJeepney.state.timeScale =
            turboData.jeepTurnSpeed[globalData.turbo];
          gameAssets.autoJeepney.state.setAnimation(0, "R_side_to_front", false);
        }
      } else {
        gameAssets.jeepney.state.timeScale =
          turboData.jeepTurnSpeed[globalData.turbo];
        gameAssets.jeepney.state.setAnimation(0, "tuktuk_R_side_to_front", false);

      }
      globalData.jeepneyLane = null;
    }
  }
  setTimeout(() => {
    if (gameAssets.autoplayInprogress) {
      if (gameAssets.turboJeepney.visible) {
        //  showFrontJeepney();
        gameAssets.turboJeepney.state.timeScale = 1;
        gameAssets.turboJeepney.state.setAnimation(0, "front_turbo2", true)
      } else {
        gameAssets.autoJeepney.state.timeScale = 1;
        gameAssets.autoJeepney.state.setAnimation(0, "front", true);
      }
    } else {
      gameAssets.jeepney.state.timeScale = 1;
      gameAssets.jeepney.state.setAnimation(0, "tuktuk_front", true);
    }
    if (gameAssets.autoplayInprogress) {
      gameAssets.autoplayInprogress = false;
    }

    if (globalData.currentRound < globalData.totalRounds)
      instances.SpinButton.updateRoundText()
    processSpinResult()

  }, turboData.centerJeepney[globalData.turbo]);


}

function setupArrows() {

  // Left Arrow Button
  gameAssets.arrowLeftEnabled = new PIXI.Sprite(PIXI.Assets.get('lane-arrow_l_chosen'));
  gameAssets.arrowLeftEnabled.anchor.set(0.5);
  gameAssets.arrowLeftEnabled.x = config.logicalWidth * 0.28;
  gameAssets.arrowLeftEnabled.y = config.logicalHeight * 0.67;
  gameAssets.arrowLeftEnabled.visible = false;
  gameAssets.gameScreen.addChild(gameAssets.arrowLeftEnabled);

  const selectText = new PIXI.Text("SELECT", gameTextStyle);
  selectText.anchor.set(0.5);
  selectText.x = 315;
  gameAssets.arrowLeftEnabled.addChild(selectText);

  gameAssets.arrowLeftHover = new PIXI.Sprite(PIXI.Assets.get('lane-arrow_l_selected'));
  gameAssets.arrowLeftHover.anchor.set(0.5);
  gameAssets.arrowLeftHover.visible = false;
  gameAssets.arrowLeftEnabled.addChild(gameAssets.arrowLeftHover);

  // Create a circular hit area for the left arrow
  const leftRadius = Math.max(gameAssets.arrowLeftEnabled.width, gameAssets.arrowLeftEnabled.height) / 2;
  gameAssets.arrowLeftEnabled.interactive = true;
  gameAssets.arrowLeftEnabled.buttonMode = true;
  gameAssets.arrowLeftEnabled.hitArea = new PIXI.Circle(0, 0, leftRadius);

  gameAssets.arrowLeftEnabled.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      if (globalData.jeepneyLane !== "L") {
        if (globalData.isJackpotActive && instances.JackpotPanel) {
          instances.JackpotPanel.hideAnticipationAnimation();
        }
        gameAssets.timer.visible = false;
        if (gameAssets.timerTween.length) {
          gameAssets.timerTween.forEach(tween => tween.kill());
          gameAssets.timerTween.length = [];
        }
        gameAssets.jeepComplete = false;
        gameAssets.normalJeepCompleted = false;
        playContinue();
        globalData.currentRound += 1;
        // instances.SpinButton.updateRoundText();
        gameAssets.arrowLeftEnabled.visible = false;
        gameAssets.arrowRightEnabled.visible = false;
        gameAssets.arrowRightEnabled.interactive = false;
        gameAssets.arrowLeftEnabled.interactive = false;

        gameAssets.menubarButton.tint = 0x606060
        gameAssets.menubarButton.interactive = false

        if (!globalData.jeepneyLane) {
          gameAssets.jeepney.state.timeScale = turboData.jeepTurnSpeed[globalData.turbo];
          gameAssets.jeepney.state.setAnimation(0, 'tuktuk_front_to_L_side', false);
          gameAssets.arrowLeftEnabled.interactive = false;
          setTimeout(() => {
            gameAssets.jeepney.state.timeScale = 1;
            gameAssets.jeepney.state.setAnimation(0, 'tuktuk_L_side', true);
            processSpinResult();
            gameAssets.arrowLeftEnabled.interactive = true;
            gameAssets.arrowRightEnabled.interactive = true;
            gameAssets.arrowLeftHover.visible = false;
            gameAssets.arrowRightHover.visible = false;
          }, turboData.timeOutDataJeepTurn[globalData.turbo]);
        }
        globalData.jeepneyLane = "L";
        playJeepneyLeft();
      }
    }
  });

  gameAssets.arrowLeftEnabled.on("pointerover", () => {
    gameAssets.arrowLeftHover.visible = true;
    gameAssets.arrowLeftEnabled.cursor = 'pointer';
  });
  gameAssets.arrowLeftEnabled.on("pointerout", () => {
    gameAssets.arrowLeftHover.visible = false;
    gameAssets.arrowLeftEnabled.cursor = 'auto';
  });

  // Right Arrow Button
  gameAssets.arrowRightEnabled = new PIXI.Sprite(PIXI.Assets.get('lane-arrow_r_chosen'));
  gameAssets.arrowRightEnabled.anchor.set(0.5);
  gameAssets.arrowRightEnabled.visible = false;
  gameAssets.arrowRightEnabled.x = config.logicalWidth * 0.72;
  gameAssets.arrowRightEnabled.y = config.logicalHeight * 0.67;
  gameAssets.gameScreen.addChild(gameAssets.arrowRightEnabled);

  gameAssets.arrowRightHover = new PIXI.Sprite(PIXI.Assets.get('lane-arrow_r_selected'));
  gameAssets.arrowRightHover.anchor.set(0.5);
  gameAssets.arrowRightHover.visible = false;
  gameAssets.arrowRightEnabled.addChild(gameAssets.arrowRightHover);

  // Create a circular hit area for the right arrow
  const rightRadius = Math.max(gameAssets.arrowRightEnabled.width, gameAssets.arrowRightEnabled.height) / 2;
  gameAssets.arrowRightEnabled.interactive = true;
  gameAssets.arrowRightEnabled.buttonMode = true;
  gameAssets.arrowRightEnabled.hitArea = new PIXI.Circle(0, 0, rightRadius);

  gameAssets.arrowRightEnabled.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      if (globalData.jeepneyLane !== "R") {
        if (globalData.isJackpotActive && instances.JackpotPanel) {
          instances.JackpotPanel.hideAnticipationAnimation();
        }
        gameAssets.timer.visible = false;
        if (gameAssets.timerTween.length) {
          gameAssets.timerTween.forEach(tween => tween.kill());
          gameAssets.timerTween.length = [];
        }
        gameAssets.jeepComplete = false;
        playContinue();
        globalData.currentRound += 1;
        // instances.SpinButton.updateRoundText();
        gameAssets.arrowLeftEnabled.visible = false;
        gameAssets.arrowRightEnabled.visible = false;
        gameAssets.arrowRightEnabled.interactive = false;
        gameAssets.arrowLeftEnabled.interactive = false;

        gameAssets.menubarButton.tint = 0x606060
        gameAssets.menubarButton.interactive = false

        if (!globalData.jeepneyLane) {
          gameAssets.jeepney.state.timeScale = turboData.jeepTurnSpeed[globalData.turbo];
          gameAssets.jeepney.state.setAnimation(0, 'tuktuk_front_to_R_side', false);
          gameAssets.arrowRightEnabled.interactive = false;
          setTimeout(() => {
            processSpinResult();
            gameAssets.jeepney.state.timeScale = 1;
            gameAssets.jeepney.state.setAnimation(0, 'tuktuk_R_side', true);
            gameAssets.arrowLeftEnabled.interactive = true;
            gameAssets.arrowRightEnabled.interactive = true;
            gameAssets.arrowLeftHover.visible = false;
            gameAssets.arrowRightHover.visible = false;
          }, turboData.timeOutDataJeepTurn[globalData.turbo]);
        }
        globalData.jeepneyLane = "R";
        playJeepneyRight();
      }
    }
  });

  gameAssets.arrowRightEnabled.on("pointerover", () => {
    gameAssets.arrowRightHover.visible = true;
    gameAssets.arrowRightEnabled.cursor = 'pointer';
  });
  gameAssets.arrowRightEnabled.on("pointerout", () => {
    gameAssets.arrowRightHover.visible = false;
    gameAssets.arrowRightEnabled.cursor = 'auto';

  });
}

function setArrowInteractivity() {
  if (globalData.autoplay) {
    gameAssets.arrowRightEnabled.interactive = false
    gameAssets.arrowLeftEnabled.interactive = false
  } else {
    gameAssets.arrowRightEnabled.interactive = true
    gameAssets.arrowLeftEnabled.interactive = true
  }
}

function arrowVisibility(visible = false) {
  if (!visible) {
    gameAssets.arrowLeftEnabled.visible = false;
    gameAssets.arrowRightEnabled.visible = false;
  } else {
    gameAssets.arrowLeftEnabled.visible = true;
    gameAssets.arrowRightEnabled.visible = true;
  }
}
export function setTotalRound(totalRounds) {
  instances.RoundPanel.roundIndex = globalData.roundSettings.indexOf(totalRounds)
  instances.RoundPanel.updateBetValueText(instances.RoundPanel.roundIndex)
}

export function setBet(bet) {
  instances.BetPanel.betIndex = globalData.betSettings.indexOf(bet)
  instances.BetPanel.updateBetValueText(instances.BetPanel.betIndex)
}

function setupGameUI() {
  gameAssets.gameScreen.addChild(instances.Obstacles.obstaclesContainer);
  //UI BAR GRAPHICS
  gameAssets.gameUI = new PIXI.Sprite(PIXI.Assets.get('Base_Container'));
  gameAssets.gameUI.anchor.set(0.5)
  gameAssets.gameUI.scale.set(config.minScaleFactor * 1)
  gameAssets.gameUI.x = window.innerWidth / 2
  gameAssets.gameUI.y = window.innerHeight - gameAssets.gameUI.height / 2 - 10

  // const mask = new PIXI.Graphics();
  // mask.beginFill(0xffffff, 0.5);
  // mask.drawRect(-config.logicalWidth / 2 + 165, - 2000, config.logicalWidth - 330, 4000);
  // mask.endFill();
  // gameAssets.gameUI.addChild(mask)
  // gameAssets.gameUI.mask = mask;

  containers.bgContainer.addChild(gameAssets.gameUI);
  // setupUIbarComponents();

  //TOP-RIGHT MENU BUTTON
  MenuButtonSetup();

  setupArrows();
  //setupRoundPanel();
  setUpMeter();
  startText();
  setupJackpotPanel();

  //classes import

  instances.WinsScreen = new winScreen();
  instances.bulbMeter = new bulbMeter()
  gameAssets.gameScreen.addChild(instances.WinsScreen.winContainer);
  instances.SpinButton = new spinButton(0, -185);
  gameAssets.gameUI.addChild(instances.SpinButton.spinButtonContainer);
  setupUIbarComponents();
  instances.RoundPanel = new roundPanel(475, -220);
  gameAssets.gameUI.addChild(instances.RoundPanel.roundPanelContainer);
  instances.BetPanel = new betPanel(-475, -220);
  gameAssets.gameUI.addChild(instances.BetPanel.betPanelContainer);
  instances.PopUpMessage = new popUp(
    config.logicalWidth / 2,
    config.logicalHeight / 2
  );
  // gameAssets.gameScreen.addChild(instances.PopUpMessage.popUpContainer);
  instances.MenuPopUp = new menuPopUp();
  gameAssets.gameScreen.addChild(instances.MenuPopUp.menuPopUp);
  gameAssets.gameUI.visible = false;

  //  createText();
  demoSimulationHelper();
  setupNetworkLoader();
}

function setupJackpotPanel() {
  instances.JackpotPanel = new jackpotPanel();
  instances.JackpotPanel.jackpotPanelSprite.anchor.set(0.5)
  instances.JackpotPanel.jackpotPanelSprite.scale.set(config.minScaleFactor)
  instances.JackpotPanel.jackpotPanelSprite.x = window.innerWidth / 2 + 33
  instances.JackpotPanel.jackpotPanelSprite.y = instances.JackpotPanel.jackpotPanelSprite.height / 2 + 10
  gameAssets.gameScreen2.addChild(instances.JackpotPanel.jackpotPanelContainer);

  hideJackpotPanel();

}

function resetJackpotPanel() {
  if (instances.JackpotPanel)
    instances.JackpotPanel.resetPanel()
}
function showGrandJackpotWin(winAmount, duration) {
  if (instances.JackpotPanel)
    instances.JackpotPanel.showGrandWin(winAmount, duration)
}

function showMajorJackpotWin(winAmount, duration) {
  if (instances.JackpotPanel)
    instances.JackpotPanel.showMajorWin(winAmount, duration)
}

function showMinorJackpotWin(winAmount, duration) {
  if (instances.JackpotPanel)
    instances.JackpotPanel.showMinorWin(winAmount, duration)
}

function showJackpotPanel(winAmount, duration) {
  if (instances.JackpotPanel)
    instances.JackpotPanel.jackpotPanelContainer.visible = true;
}

function hideJackpotPanel(winAmount, duration) {
  if (instances.JackpotPanel)
    instances.JackpotPanel.jackpotPanelContainer.visible = false;
}

function controlJackpotWinSpine(winTypeIndex, play) {
  if (instances.JackpotPanel) {
    if (winTypeIndex === 2 && play)
      instances.JackpotPanel.showGrandWinSpine();
    else
      instances.JackpotPanel.hideGrandWinSpine();
    if (winTypeIndex === 1 && play)
      instances.JackpotPanel.showMajorWinSpine();
    else
      instances.JackpotPanel.hideMajorWinSpine();
    if (winTypeIndex === 0 && play)
      instances.JackpotPanel.showMinorWinSpine();
    else
      instances.JackpotPanel.hideMinorWinSpine();
  }
}


function setupNetworkLoader() {
  instances.NetworkLoader = new loader()
  gameAssets.gameScreen.addChild(instances.NetworkLoader.loadingContainer);
  // setTimeout(() => {
  //   instances.NetworkLoader.showLoader()
  // }, 2 * 1000);
  // setTimeout(() => {
  //   instances.NetworkLoader.hideLoader()
  // }, 5 * 1000);
}
function parseJackpotResult() {
  if (globalData.jackpotGrandWin) {
    globalData.jackpot = true;
    globalData.jackpotWin = globalData.jackpotGrandWinAmount;
  } else if (globalData.jackpotMajorWin) {
    globalData.jackpot = true;
    globalData.jackpotWin = globalData.jackpotMajorWinAmount;
  } else if (globalData.jackpotMinorWin) {
    globalData.jackpot = true;
    globalData.jackpotWin = globalData.jackpotMinorWinAmount;
  } else {
    globalData.jackpot = false;
    globalData.jackpotWin = 0;
  }

}

function checkGrandJackpotVisible() {
  return instances.WinsScreen.grandJackpotSpine.visible
}

function checkMajorJackpotVisible() {
  return instances.WinsScreen.majorJackpotSpine.visible
}
function demoSimulationHelper() {
  gameAssets.demoButton = new PIXI.Sprite(PIXI.Assets.get("menu_b_normal"));
  gameAssets.demoButton.anchor.set(0.5);
  gameAssets.demoButton.scale.set(1);
  gameAssets.demoButton.x = config.logicalWidth * 0.35;
  gameAssets.demoButton.y = 0;
  gameAssets.gameUI.addChild(gameAssets.demoButton);
  gameAssets.demoButton.interactive = true;
  gameAssets.demoButton.alpha = 0.01;

  const style = new PIXI.TextStyle({
    dropShadow: true,
    dropShadowDistance: 5,
    stroke: 0,
    strokeThickness: 6,
    fill: "#fff000",
    fontFamily: "Arial",
    fontSize: 30,
    fontWeight: "700",
    align: "center",
  });

  if (!gameAssets.cheatMessage)
    gameAssets.cheatMessage = new PIXI.Text("No data received!", style);
  gameAssets.cheatMessage.y = -1850;
  gameAssets.cheatMessage.x = 0;
  gameAssets.cheatMessage.anchor.set(0.5);
  gameAssets.cheatMessage.visible = false;
  gameAssets.gameUI.addChild(gameAssets.cheatMessage);

  // gameAssets.demoButton.on('pointerdown', (event) => {
  //   if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {

  //     // if (globalData.stats.visible) {
  //     //   document.body.removeChild(globalData.stats.dom); // Remove FPS meter
  //     //   globalData.stats.visible = false; // Set the visibility flag to false
  //     // } else {
  //     //   document.body.appendChild(globalData.stats.dom); // Add FPS meter
  //     //   globalData.stats.visible = true; // Set the visibility flag to true
  //     // }

  //     gameAssets.cheatMessage.visible = !gameAssets.cheatMessage.visible
  //     // if (!globalData.jackpot)
  //     // globalData.jackpot = false;
  //     // else if (globalData.jackpot && globalData.jackpotWin === 0) globalData.jackpot = false;
  //   }
  // })


}

function startText() {
  gameAssets.startTextContainer = new PIXI.Container();
  gameAssets.startTextContainer.visible = false;
  gameAssets.startText = new PIXI.BitmapText("Let's", {
    fontName: "normal-font",
    fontSize: 35,
    align: "center",
    letterSpacing: -10,
  });
  gameAssets.startText.anchor.set(0.5);
  gameAssets.startText.x = 10;
  gameAssets.startText.y = -60;
  gameAssets.startTextContainer.addChild(gameAssets.startText);

  const go = new PIXI.BitmapText("GO!", {
    fontName: "normal-font",
    fontSize: 45,
    align: "center",
    letterSpacing: -10,
  });
  go.anchor.set(0.5);
  go.x = 0;
  go.y = 100;
  gameAssets.startTextContainer.addChild(go);

  const style = new PIXI.TextStyle({
    dropShadow: true,
    dropShadowAngle: 1,
    dropShadowBlur: 0,
    dropShadowColor: 0,
    dropShadowDistance: 5,
    stroke: 0,
    strokeThickness: 6,
    fill: "#fff000",
    fontFamily: "Arial",
    fontSize: 48,
    fontWeight: "700",
    align: "center",
  });

  const betMessage = new PIXI.Text("Choose Bet & Rounds", style);
  betMessage.y = 260;
  betMessage.x = 0;
  betMessage.anchor.set(0.5);

  gameAssets.startTextContainer.addChild(betMessage);
  gameAssets.startTextContainer.initialX = config.logicalWidth * 0.5;
  gameAssets.startTextContainer.initialY = config.logicalHeight * 0.7;
  gameAssets.startTextContainer.finalX = config.logicalWidth * 0.5;
  gameAssets.startTextContainer.finalY = config.logicalHeight * 0.688;
  gameAssets.startTextContainer.x = config.logicalWidth * 0.5;
  gameAssets.startTextContainer.y = config.logicalHeight * 0.688;
  gameAssets.gameScreen.addChild(gameAssets.startTextContainer);
}

function rebootButton() {
  instances.SpinButton.roundText.visible = false;
  instances.SpinButton.hitGraphics.alpha = 0.99
}

// const loader = new PIXI.Loader()
// loader.add('big-win', path / font + 'big-win.fnt').load(() => {
//   // Once font has been loaded, call a function that uses it
//   createText()
// })
function createText() {
  const text = new PIXI.BitmapText("Hello Bitmap Font", {
    font: "big-win",
    align: "center",
  });
  text.anchor.set(0.5);
  text.position.x = config.logicalWidth / 2;
  text.position.y = config.logicalHeight / 2;
  gameAssets.gameScreen.addChild(text);
}
function setUpMeter() {
  instances.Meter = new meter();
  gameAssets.gameScreen.addChild(instances.Meter.meterContainer);
  if (globalData.isJackpotActive)
    instances.Meter.meterContainer.y = 520;
  else
    instances.Meter.meterContainer.y = 0;

}
function changeRoundNumber() {
  instances.Meter.createMeterContent();
}
function MenuButtonSetup() {
  gameAssets.menubarButton = new PIXI.Sprite(PIXI.Assets.get("menu_b_normal"));
  gameAssets.menubarButton.anchor.set(0.5);
  gameAssets.menubarButton.scale.set(config.minScaleFactor)
  gameAssets.menubarButton.x = window.innerWidth / 2 + 33
  gameAssets.menubarButton.y = gameAssets.menubarButton.height / 2 + 10
  gameAssets.gameScreen2.addChild(gameAssets.menubarButton);
  gameAssets.menubarButton.visible = false

  const menuButtonSelect = new PIXI.Sprite(PIXI.Assets.get("menu_b_selected"));
  menuButtonSelect.anchor.set(0.5);
  menuButtonSelect.visible = false;
  gameAssets.menubarButton.addChild(menuButtonSelect);

  //menu button logic
  gameAssets.menubarButton.interactive = true;
  gameAssets.menubarButton.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      gameAssets.timer.visible = false
      if (gameAssets.timerTween.length) {
        gameAssets.timerTween.forEach(tween => tween.kill());
        gameAssets.timerTween.length = [];
      }
      instances.MenuPopUp.enable();
      playPopUpOpen();
      stopBg();
      instances.Meter.stopPulsate()
      instances.JackpotPanel.jackpotPanelSprite.visible = false;
      gameAssets.menubarButton.alpha = 0.8;
      gameAssets.menubarButton.tint = 0x303030
      gameAssets.menubarButton.interactive = false;
      menuButtonSelect.visible = false;
    }
  });

  gameAssets.menubarButton.on("pointerover", () => {
    menuButtonSelect.visible = true;
    gameAssets.menubarButton.cursor = "pointer";
  });
  gameAssets.menubarButton.on("pointerout", () => {
    menuButtonSelect.visible = false;
  });
}

function stopBg() {
  gameAssets.birds.visible = false;
  gameAssets.foreground.state.timeScale = 0;
  gameAssets.midground.state.timeScale = 0;
  gameAssets.background.state.timeScale = 0;
  gameAssets.ambientBackground.state.timeScale = 0;
  instances.Meter.meterSpeed = 0;
  leavesSpine.state.timeScale = 0;
}

function setupRoundPanel() {
  gameAssets.RoundPanel = new PIXI.Sprite(PIXI.Assets.get("rounds_panel"));
  gameAssets.RoundPanel.anchor.set(0.5);
  gameAssets.RoundPanel.scale.set(0.75);
  gameAssets.RoundPanel.position.set(360, 675);
  gameAssets.gameScreen.addChild(gameAssets.RoundPanel);
}

function setupUIbarComponents() {
  const style = new PIXI.TextStyle({
    dropShadow: true,
    dropShadowAngle: 0,
    dropShadowBlur: 0,
    dropShadowColor: 0,
    dropShadowDistance: 0,
    stroke: 0,
    strokeThickness: 1,
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: 55,
    fontWeight: "bold",
    align: "center",
  });

  const style2 = new PIXI.TextStyle({
    dropShadow: true,
    dropShadowAngle: 0,
    dropShadowBlur: 0,
    dropShadowColor: 0,
    dropShadowDistance: 0,
    stroke: 0,
    strokeThickness: 1,
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: 60,
    fontWeight: "bold",
    align: "center",
  });

  gameAssets.balanceValueText = new PIXI.Text(globalData.balance, style);
  gameAssets.balanceValueText.y = 20;
  gameAssets.balanceValueText.x = -445;
  gameAssets.balanceValueText.anchor.set(0.5);

  // const length = gameAssets.balanceValueText.text.length * 25
  gameAssets.balanceIcon = new PIXI.Sprite(PIXI.Assets.get('balance'))
  gameAssets.balanceIcon.anchor.set(1, 0.5)
  gameAssets.balanceIcon.scale.set(1)
  const xPos = -gameAssets.balanceValueText.width * 0.5 - gameAssets.balanceIcon.width * 0.5
  gameAssets.balanceIcon.x = -645
  gameAssets.balanceIcon.y = 5;
  gameAssets.gameUI.addChild(gameAssets.balanceIcon)
  // gameAssets.balanceValueText.addChild(gameAssets.balanceIcon)

  gameAssets.totalBetValueText = new PIXI.Text("250", style2);
  gameAssets.totalBetValueText.y = 20;
  gameAssets.totalBetValueText.x = 465;
  gameAssets.totalBetValueText.anchor.set(0.5);

  const headerStyle = new PIXI.TextStyle({
    dropShadow: true,
    dropShadowAngle: 0,
    dropShadowBlur: 0,
    dropShadowColor: 0,
    dropShadowDistance: 0,
    stroke: 0,
    strokeThickness: 0,
    fill: 0x999999,
    fontFamily: "Arial",
    fontSize: 40,
    fontWeight: 600,
    align: "center",
  });
  const balHeader = new PIXI.Text("BALANCE", headerStyle);
  balHeader.anchor.set(0.5);
  balHeader.y = -30;
  balHeader.x = -440
  const betHeader = new PIXI.Text("TOTAL BET", headerStyle);
  betHeader.anchor.set(0.5);
  betHeader.y = -45;

  betHeader.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
    }
  })

  gameAssets.totalBetValueText.addChild(betHeader);
  // gameAssets.balanceValueText.addChild(balHeader);
  gameAssets.gameUI.addChild(balHeader)

  gameAssets.autoPlayNormal = new PIXI.Sprite(PIXI.Assets.get('autoNormal'))
  gameAssets.autoPlayNormal.anchor.set(0.5)
  gameAssets.autoPlayNormal.scale.set(1)
  gameAssets.autoPlayNormal.x = -194
  gameAssets.autoPlayNormal.y = -20
  // gameAssets.autoPlayNormal.interactive = true;
  // gameAssets.autoPlayNormal.cursor = 'pointer'

  autoGraphic = new PIXI.Graphics();
  autoGraphic.beginFill(0x202020, 1);
  autoGraphic.drawCircle(0, 0, 75);
  autoGraphic.endFill();
  autoGraphic.alpha = 0
  autoGraphic.interactive = true;
  autoGraphic.cursor = 'pointer'

  autoGraphic.on('pointerdown', async (event) => {
    if ((!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') && globalData.turboTimeOut) {
      //console.log("timeout click", globalData.turboTimeOut)
      globalData.turboTimeOut = false;
      setTimeout(() => {
        // console.log("timeout ", globalData.turboTimeOut)
        globalData.turboTimeOut = true;
      }, 500);
      const online = await isOnline();
      if (online || tuktukDemoState.isDemo) {
        if (gameAssets.autoplayEnabled.visible) {
          globalData.autoplay = false;
          globalData.turbo = 0

          if (!globalData.jeepneyLane && gameAssets.jeepComplete && gameAssets.autoJeepComplete && gameAssets.turboJeepComplete) {
            //  gameAssets.speedLinesFx.visible = false;
            gameAssets.menubarButton.tint = 0xffffff
            gameAssets.menubarButton.interactive = true

            if (gameAssets.turboJeepney.visible) {
              gameAssets.transition.visible = true
              gameAssets.turboJeepney.visible = false;
              gameAssets.transition.state.setAnimation(0, 'front_turbo2_off_to_tuktuk', false).listener = {
                complete: () => {
                  setTimeout(() => {
                    gameAssets.jeepney.state.setAnimation(0, "tuktuk_front", true)
                    gameAssets.transition.visible = false
                    gameAssets.jeepney.visible = true;
                    gameAssets.jeepney.state.timeScale = 1;
                  }, 0);
                }
              }
            } else {
              gameAssets.jeepney.state.setAnimation(0, "tuktuk_front", true)
              gameAssets.autoJeepney.visible = false;
              gameAssets.jeepney.visible = true;
              gameAssets.jeepney.state.timeScale = 1;
            }
          }

          // if (globalData.currentGameState !== gameStates.ROUND_CONTINUE && globalData.currentGameState !== gameStates.ROUND_END) {
          //   gameAssets.menubarButton.tint = 0xffffff
          //   gameAssets.menubarButton.interactive = true
          // }
          setArrowInteractivity()
          gameAssets.autoplayEnabled.visible = false
          gameAssets.turboEnabled.visible = false
          playOff()
        } else {
          globalData.autoplay = true;
          // console.log("wufgerugfuerf", gameAssets.turboCompleted, gameAssets.normalJeepCompleted);


          if (!globalData.jeepneyLane && gameAssets.jeepComplete && gameAssets.autoJeepComplete && gameAssets.turboJeepComplete) {
            if (gameAssets.turboJeepney.visible) gameAssets.turboJeepney.visible = false;
            gameAssets.jeepney.visible = false;
            gameAssets.autoJeepney.visible = true;
            gameAssets.autoJeepney.state.timeScale = 1;
            gameAssets.autoJeepney.state.setAnimation(0, "front", true)
          }


          // if (globalData.currentGameState !== gameStates.ROUND_CONTINUE && globalData.currentGameState !== gameStates.ROUND_END) {

          // }
          setArrowInteractivity()
          gameAssets.autoplayEnabled.visible = true
          playOn()
          if (globalData.currentGameState === gameStates.ROUND_START && !globalData.jeepneyLane && gameAssets.jeepComplete && gameAssets.autoJeepComplete && gameAssets.turboJeepComplete) {
            autoplayRound("auto");
          }
        }
      }
      else {
        showErrorPopup("No Internet connection");
      }
    }
  });

  gameAssets.autoplayEnabled = new PIXI.Sprite(PIXI.Assets.get("autoEnable"));
  gameAssets.autoplayEnabled.anchor.set(0.5);
  gameAssets.autoPlayNormal.addChild(gameAssets.autoplayEnabled, autoGraphic);
  gameAssets.autoplayEnabled.visible = false;

  gameAssets.turboNormal = new PIXI.Sprite(PIXI.Assets.get('SpeedNormal'))
  gameAssets.turboNormal.anchor.set(0.5)
  gameAssets.turboNormal.scale.set(1)
  gameAssets.turboNormal.x = 195
  gameAssets.turboNormal.y = -20
  // gameAssets.turboNormal.interactive = true;
  // gameAssets.turboNormal.cursor = 'pointer';

  turboGraphic = new PIXI.Graphics();
  turboGraphic.beginFill(0x202020, 1);
  turboGraphic.drawCircle(0, 0, 75);
  turboGraphic.endFill();
  turboGraphic.alpha = 0
  turboGraphic.interactive = true
  turboGraphic.cursor = 'pointer'

  turboGraphic.on('pointerdown', async (event) => {
    if ((!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') && globalData.turboTimeOut) {
      //console.log("timeout click", globalData.turboTimeOut)
      globalData.turboTimeOut = false;
      setTimeout(() => {
        // console.log("timeout ", globalData.turboTimeOut)
        globalData.turboTimeOut = true;
      }, 500);
      const online = await isOnline();
      if (online || tuktukDemoState.isDemo) {
        if (gameAssets.turboEnabled.visible) {
          globalData.turbo = 0;
          gameAssets.turboEnabled.visible = false;
          gameAssets.autoplayEnabled.visible = false;


          if (globalData.currentGameState !== gameStates.IDLE) {
            updateGameSpeed();
          }
          else {
            gameAssets.speedLinesFx.visible = false;
            updateGameSpeed(0.4)
          }

          if (!globalData.jeepneyLane && gameAssets.jeepComplete && gameAssets.autoJeepComplete && gameAssets.turboJeepComplete) {
            gameAssets.menubarButton.tint = 0xffffff
            gameAssets.menubarButton.interactive = true

            gameAssets.autoJeepney.visible = false;
            gameAssets.transition.visible = true
            gameAssets.turboJeepney.visible = false;
            gameAssets.transition.state.setAnimation(0, 'front_turbo2_off_to_tuktuk', false).listener = {
              complete: () => {
                gameAssets.jeepney.state.setAnimation(0, "tuktuk_front", true);
                gameAssets.transition.visible = false
                gameAssets.jeepney.visible = true;
                gameAssets.jeepney.state.timeScale = 1;
              }
            };
          }

          globalData.autoplay = false;
          // if (globalData.currentGameState !== gameStates.ROUND_CONTINUE && globalData.currentGameState !== gameStates.ROUND_END) {
          //   gameAssets.menubarButton.tint = 0xffffff
          //   gameAssets.menubarButton.interactive = true
          // }
          setArrowInteractivity()
          playOff()
        } else {

          globalData.turbo = 1;
          gameAssets.turboEnabled.visible = true;
          gameAssets.autoplayEnabled.visible = true;

          if (globalData.currentGameState !== gameStates.IDLE) {
            updateGameSpeed();
          }
          else {
            updateGameSpeed(0.4)
          }

          if (!globalData.jeepneyLane && gameAssets.jeepComplete && gameAssets.autoJeepComplete && gameAssets.turboJeepComplete) {
            gameAssets.speedLinesFx.visible = true;
            gameAssets.autoJeepney.visible = false;
            gameAssets.jeepney.visible = false;
            gameAssets.turboJeepney.visible = true;
            gameAssets.turboJeepney.state.timeScale = 1;
            gameAssets.transition.visible = true
            gameAssets.transition.state.setAnimation(0, 'front_turbo2_on', false).listener = {
              complete: () => {
                gameAssets.turboJeepney.state.setAnimation(0, "front_turbo2", true);
                gameAssets.transition.visible = false
                //  showFrontJeepney();
              }
            };
          }

          globalData.autoplay = true;

          setArrowInteractivity()
          playOn()
          if (globalData.currentGameState === gameStates.ROUND_START && !globalData.jeepneyLane && gameAssets.jeepComplete && gameAssets.autoJeepComplete && gameAssets.turboJeepComplete) {
            autoplayRound("turbo");
          }
        }
      }
      else {
        showErrorPopup("No Internet connection");
      }
    }
  });

  gameAssets.turboEnabled = new PIXI.Sprite(PIXI.Assets.get("speedEnable"));
  gameAssets.turboEnabled.anchor.set(0.5);
  gameAssets.turboNormal.addChild(gameAssets.turboEnabled, turboGraphic);
  gameAssets.turboEnabled.visible = false;

  gameAssets.gameUI.addChild(
    gameAssets.balanceValueText,
    gameAssets.totalBetValueText,
    ...(globalData.showAutoAndTurbo ? [gameAssets.autoPlayNormal, gameAssets.turboNormal] : [])
  );
}
function setTurboVisiblity(value, isInteractive) {
  turboGraphic.alpha = value;
  if (isInteractive) gameAssets.turboNormal.interactive = true;
  else gameAssets.turboNormal.interactive = false;
}

function setAutoVisiblity(value, isInteractive) {
  autoGraphic.alpha = value;
  if (isInteractive) gameAssets.autoPlayNormal.interactive = true;
  else gameAssets.autoPlayNormal.interactive = false;
}

function updateTotalBet() {
  globalData.totalBet = globalData.bet * globalData.betMultiplier;
  gameAssets.totalBetValueText.text = globalData.totalBet;
  if (instances.Meter.multipliersText[1])
    instances.Meter.updateMultiplierText();
  if (globalData.totalBet > globalData.balance) {
    gameAssets.balanceValueText.style.fill = 0xff6876;
  } else if (gameAssets.balanceValueText.style.fill != 0xffffff) {
    gameAssets.balanceValueText.style.fill = 0xffffff;
  }
}
function updateBalance() {
  gameAssets.balanceValueText.text = formatBalance(globalData.balance);
  // gameAssets.balanceValueText.text = 9;
  const xPos =
    -gameAssets.balanceValueText.width * 0.5 -
    gameAssets.balanceIcon.width * 0.5;
  // const length = gameAssets.balanceValueText.text.length * 25
  const maxAllowedWidth = 320;
  const currentWidth = gameAssets.balanceValueText.width;

  if (currentWidth > maxAllowedWidth) {
    const scaleFactor = maxAllowedWidth / currentWidth;
    gameAssets.balanceValueText.scale.set(scaleFactor);
  }
  gameAssets.balanceIcon.x = globalData.balance > 999 ? gameAssets.balanceValueText.x - gameAssets.balanceValueText.width * 0.5 : -550
  // gameAssets.balanceIcon.x = -length
  if (globalData.totalBet > globalData.balance) {
    gameAssets.balanceValueText.style.fill = 0XFF6876
  } else if (gameAssets.balanceValueText.style.fill != 0XFFFFFF) {
    gameAssets.balanceValueText.style.fill = 0XFFFFFF
  }
}

function ShowInsufficientBalancePopup() {
  instances.PopUpMessage.popUp(
    "INSUFFICIENT\nBALANCE",
    "Oops! Balance Too Low.\nYou don’t have enough funds to proceed. Add more and keep the game going!"
  );
}


function showErrorPopup(description = "Please re-login!") {
  instances.PopUpMessage.popUp("NETWORK ERROR", description)
}

function showManualPopup(str, description) {
  instances.PopUpMessage.popUp(str, description);
}

function updateLoopGame(dt) {
  // if (gameAssets.meterMask.height <= globalData.currentMeterHeight) {
  //   gameAssets.meterMask.height += 5;
  //   if (gameAssets.meterMask.height > globalData.meterHeightMax) {
  //     gameAssets.meterMask.height = globalData.meterHeightMax
  //   }
  // }
  // else if (gameAssets.meterMask.height >= globalData.currentMeterHeight) {
  //   gameAssets.meterMask.height -= 5;
  //   if (gameAssets.meterMask.height < 0) {
  //     gameAssets.meterMask.height = 0
  //   }
  // }

  gameAssets.birds.x -= dt * 2;
  gameAssets.birds.alpha -= dt * 0.00125;
  if (gameAssets.birds.x <= -300) {
    gameAssets.birds.x = config.logicalWidth * 1;
    gameAssets.birds.alpha = 1;
  }

  if (instances.WinsScreen) instances.WinsScreen.update(dt);
  if (instances.Meter) instances.Meter.update(dt);
}

function resizeGameUI() {
  if (window.innerWidth < 500) {
    gameAssets.gameScreen.x = 0
    gameAssets.gameUI.x = window.innerWidth / 2
    const scaleX = window.innerWidth / config.logicalWidth;

    gameAssets.gameScreen.scale.set(scaleX, config.minScaleFactor);
    gameAssets.gameUI.scale.set(scaleX, config.minScaleFactor)
  } else {

    gameAssets.gameScreen.x = config.minLeftX;
    gameAssets.gameScreen.scale.set(config.minScaleFactor);
    gameAssets.gameUI.scale.set(config.minScaleFactor * 1)
    gameAssets.gameUI.x = window.innerWidth / 2
    gameAssets.gameUI.initialX = gameAssets.gameUI.finalX = gameAssets.gameUI.x
  }
  gameAssets.gameScreen.y = config.minTopY;

  if (globalData.isJackpotActive) {
    instances.JackpotPanel.jackpotPanelSprite.scale.set(config.minScaleFactor)
    instances.JackpotPanel.jackpotPanelSprite.x = window.innerWidth / 2 + (90 * config.minScaleFactor)
    instances.JackpotPanel.jackpotPanelSprite.y = instances.JackpotPanel.jackpotPanelSprite.height / 2 + 10
  }

  gameAssets.menubarButton.scale.set(config.minScaleFactor)
  gameAssets.menubarButton.x = window.innerWidth / 2 - (625 * config.minScaleFactor)
  gameAssets.menubarButton.y = 10 + gameAssets.menubarButton.height / 2

  gameAssets.gameUI.y = window.innerHeight - gameAssets.gameUI.height / 2
  gameAssets.gameUI.initialY = gameAssets.gameUI.finalY = gameAssets.gameUI.y
}

function setupContainers() {
  pixiApp.app.stage.addChild(containers.rootContainer);
  containers.rootContainer.addChild(containers.bgContainer);
}
function setUpMask() {
  gameAssets.PageMask = new PIXI.Sprite(PIXI.Assets.get("gameScreen"));
  gameAssets.PageMask.anchor.set(0.5);
  gameAssets.PageMask.scale.set(1);
  gameAssets.PageMask.alpha = 1;
  gameAssets.PageMask.width = config.logicalWidth;
  gameAssets.PageMask.height = 1340;
  gameAssets.PageMask.x = 0;
  gameAssets.PageMask.y = 0;
  containers.pageContainer.addChild(gameAssets.PageMask);
  containers.pageContainer.sortableChildren = true
}

function rulesPageContant(temp) {
  globalData.tutorialPageSize = 11
  if (globalData.isJackpotActive) {
    globalData.tutorialPageSize = 12
  }
  gameAssets.gameScreen.addChild(containers.pageContainer);
  containers.pageContainer.x = config.logicalWidth / 2;
  containers.pageContainer.y = config.logicalHeight / 2.5;

  const dimmer = new PIXI.Sprite(PIXI.Assets.get("dimmer"));
  dimmer.anchor.set(0.5);
  dimmer.tint = 0;
  dimmer.x = 0;
  dimmer.y = 400;
  dimmer.scale.set(3);
  dimmer.alpha = 0.95;
  dimmer.interactive = true;
  containers.pageContainer.addChild(dimmer);

  skip("English");
  containers.pageContainer.visible = true;
  containers.pageContainer.addChild(containers.imageContainer);

  let pageArray1 = temp;
  for (let i = 0; i < globalData.tutorialPageSize; i++) {
    gameAssets.page[i] = new PIXI.Container();
    if (i < globalData.tutorialPageSize - 1) {
      const pageSprite = new PIXI.Sprite(PIXI.Assets.get(pageArray1[i]));
      pageSprite.mask = gameAssets.PageMask;
      pageSprite.anchor.set(0.5);
      pageSprite.x = 0;
      pageSprite.y = 0;
      pageSprite.scale.set(i === 0 ? 2 : 2);

      // if (i === 6) {
      //   pageSprite.scale.set(globalData.isJackpotActive ? 1.4 : 2.45);
      //   pageSprite.y = globalData.isJackpotActive ? 150 : 10
      // }
      if (i == 6) {
        pageSprite.scale.set(2.1)
      }

      if (i == 8) {
        pageSprite.y = globalData.isJackpotActive ? 100 : 5
        pageSprite.scale.set(globalData.isJackpotActive ? 1.6 : 2.3)
      }

      if (i == 9) {
        if(globalData.isJackpotActive){
          pageSprite.y = 30;
          pageSprite.scale.set(2.3)
        } else {
          pageSprite.y = 0;
          pageSprite.scale.set(1.75)
        }
      }

      if(i == 10){
        pageSprite.y = 0;
        pageSprite.scale.set(1.75)
      }
      if (i === 7 && globalData.isJackpotActive) {
        pageSprite.scale.set(2.4);
      }
      if (i === 2) {
        const container = gameAssets.page[i]; // the container you're dragging
        const content = pageSprite; // the sprite inside the container

        container.interactive = true;
        container.cursor = "grab";
        content.scale.set(1);
        content.y = 0; // sprite stays fixed in its container

        const maskHeight = gameAssets.PageMask.height;
        const contentHeight = content.height * content.scale.y;

        const maxY = 670; // initial y
        const minY = maxY - (contentHeight - maskHeight); // adjust for scrolling bounds

        container.y = maxY; // Initial container position

        const scrollSpeedFactor = 0.5;
        let dragging = false;
        let startPointerY = 0;
        let startY = 0;

        container.on("pointerdown", (event) => {
          dragging = true;
          startPointerY = event.data.global.y;
          startY = container.y;
          container.cursor = "grabbing";
        });

        container.on("pointermove", (event) => {
          if (dragging) {
            const deltaY = (event.data.global.y - startPointerY) * scrollSpeedFactor;
            let newY = startY + deltaY;
            container.y = Math.min(maxY, Math.max(newY, minY));

            // arrow visibility toggle
            if (gameAssets.page[2].y < -680) {
              gameAssets.arrow.visible = false;
            } else {
              gameAssets.arrow.visible = true;
            }
            globalData.ftuePrizeScroll = false;
          }
        });

        container.on("pointerup", () => {
          dragging = false;
          container.cursor = "grab";
        });

        container.on("pointerupoutside", () => {
          dragging = false;
          container.cursor = "grab";
        });
      }


      gameAssets.page[i].addChild(pageSprite);
      gameAssets.page[i].visible = false;
      containers.imageContainer.addChild(gameAssets.page[i]);
    } else {
      if (!globalData.showAutoAndTurbo) {
        const pageSprite1 = new PIXI.Sprite(PIXI.Assets.get('p8_content_without_auto'));
        pageSprite1.anchor.set(0.5);
        pageSprite1.scale.set(2.4);
        pageSprite1.x = 0;
        pageSprite1.y = 25;

        gameAssets.page[i].addChild(pageSprite1);
      } else {
        const pageSprite1 = new PIXI.Sprite(PIXI.Assets.get('p7_new_content_EN'));
        pageSprite1.anchor.set(0.5);
        pageSprite1.scale.set(2.7);
        pageSprite1.x = 0;
        pageSprite1.y = 0;

        gameAssets.page[i].addChild(pageSprite1);
        gameAssets.page[i].visible = false;
        gameAssets.page[i].interactive = true;
        gameAssets.page[i].mask = gameAssets.PageMask;

        const contentHeight = pageSprite1.height * pageSprite1.scale.y;
        const maskHeight = gameAssets.PageMask.height;

        const maxY = 2240;
        const minY = maxY - (contentHeight - maskHeight) / 3.21;

        gameAssets.page[i].y = maxY;
        let dragging = false;
        let startPointerY = 0;
        let startY = 0;

        gameAssets.page[i].cursor = "grab";

        gameAssets.page[i].on("pointerdown", (event) => {
          dragging = true;
          startPointerY = event.data.global.y;
          startY = gameAssets.page[i].y;
          gameAssets.page[i].cursor = "grabbing";
        });

        gameAssets.page[i].on("pointermove", (event) => {
          if (dragging) {
            const deltaY = event.data.global.y - startPointerY;
            let newY = startY + deltaY;

            // Clamp within bounds
            newY = Math.min(maxY, Math.max(newY, minY));
            gameAssets.page[i].y = newY;

            if (gameAssets.page[gameAssets.page.length - 1].y < -2270) {
              gameAssets.arrow.visible = false;
            } else {
              gameAssets.arrow.visible = true;
            }
            globalData.ftueIsScroll = false;
          }
        });

        gameAssets.page[i].on("pointerup", () => {
          dragging = false;
          gameAssets.page[i].cursor = "grab";
        });

        gameAssets.page[i].on("pointerupoutside", () => {
          dragging = false;
          gameAssets.page[i].cursor = "grab";
        });
      }


    }


    containers.pageContainer.addChild(gameAssets.page[i]);
  }
}

function rulesPageContantTag(temp) {
  // globalData.isJackpotActive = true
  // console.log("r22 tag",globalData.isJackpotActive);
  globalData.tutorialPageSize = 11
  if (globalData.isJackpotActive) {
    globalData.tutorialPageSize = 12
  }
  gameAssets.gameScreen.addChild(containers.pageContainer);
  containers.pageContainer.x = config.logicalWidth / 2;
  containers.pageContainer.y = config.logicalHeight / 2.5;
  const dimmer = new PIXI.Sprite(PIXI.Assets.get("dimmer"));
  dimmer.anchor.set(0.5);
  dimmer.tint = 0;
  dimmer.x = 0
  dimmer.y = 400
  dimmer.scale.set(3)
  dimmer.alpha = 0.95
  dimmer.interactive = true;
  containers.pageContainer.addChild(dimmer);
  skip("Tagalog");
  containers.pageContainer.visible = true;
  containers.pageContainer.addChild(containers.imageContainer);
  let pageArray1 = temp
  for (let i = 0; i < globalData.tutorialPageSize; i++) {
    gameAssets.page[i] = new PIXI.Container();
    if (i < globalData.tutorialPageSize - 1) {
      const pageSprite = new PIXI.Sprite(PIXI.Assets.get(pageArray1[i]));
      pageSprite.mask = gameAssets.PageMask;
      pageSprite.anchor.set(0.5);
      pageSprite.x = 0;
      pageSprite.y = 0;


      if (i == 0) {
        pageSprite.scale.set(1.95)
      } else if (i == 5) {
        pageSprite.scale.set(2.5)
      } else if (i == 6) {
        pageSprite.scale.set(globalData.isJackpotActive ? 1.15 : 2)
        pageSprite.y = 30;
      } else if (i == 3) {
        pageSprite.scale.set(2.5);
      } else {
        pageSprite.scale.set(1);
      }

      if (i == 8) {
        pageSprite.y = globalData.isJackpotActive ? 0 : 5
        pageSprite.scale.set(globalData.isJackpotActive ? 1.55 : 1.8)
      }

      if (i == 9) {
        if(globalData.isJackpotActive){
          pageSprite.scale.set(1.75)
        } else {
          pageSprite.scale.set(2.05)
        }
      }

      if(i == 10){
        pageSprite.scale.set(2.05)
      }
      if (i === 7) {
        pageSprite.scale.set(2.1)
      }
      if (i === 2) {
        const container = gameAssets.page[i];
        const content = pageSprite;

        // Setup sprite inside the container
        content.interactive = false;
        content.scale.set(1);
        content.y = 0; // Place at top of container
        content.cursor = ""; // No interaction on sprite

        // Set container properties
        container.interactive = true;
        container.cursor = "grab";

        const maskHeight = gameAssets.PageMask.height;
        const contentHeight = content.height * content.scale.y;

        const maxY = 780; // Initial position
        const minY = maxY - (contentHeight - maskHeight) + 270; // Lower limit based on content overflow

        container.y = maxY; // Initial position
        const scrollSpeedFactor = 1;

        // Pointer events
        container.on("pointerdown", (event) => {
          gameAssets.pointerDown = true;
          gameAssets.startPointerY = event.data.global.y;
          gameAssets.startContainerY = container.y;
          container.cursor = "grabbing";
        });

        container.on("pointermove", (event) => {
          if (gameAssets.pointerDown) {
            const deltaY = (event.data.global.y - gameAssets.startPointerY) * scrollSpeedFactor;
            let newY = gameAssets.startContainerY + deltaY;

            newY = Math.min(maxY, Math.max(newY, minY)); // clamp within bounds
            container.y = newY;


            if (gameAssets.page[2].y < -575) {
              gameAssets.arrow.visible = false;
            } else {
              gameAssets.arrow.visible = true;
            }
            globalData.ftuePrizeScroll = false;

          }
        });

        container.on("pointerup", () => {
          gameAssets.pointerDown = false;
          container.cursor = "grab";
        });

        container.on("pointerupoutside", () => {
          gameAssets.pointerDown = false;
          container.cursor = "grab";
        });
      }


      if (i === 4) {
        pageSprite.x = 0;
        pageSprite.y = 5;
        pageSprite.scale.set(2.4)
      }

      gameAssets.page[i].addChild(pageSprite);
      gameAssets.page[i].visible = false;
      containers.imageContainer.addChild(gameAssets.page[i]);
    } else {
      if (!globalData.showAutoAndTurbo) {
        const pageSprite1 = new PIXI.Sprite(PIXI.Assets.get('p8_content_ph_without_auto'));
        pageSprite1.anchor.set(0.5);
        pageSprite1.scale.set(2.4);
        pageSprite1.y = 10;
        gameAssets.page[i].addChild(pageSprite1);
        gameAssets.page[i].visible = false;
        gameAssets.page[i].mask = gameAssets.PageMask;
      } else {
        // Multi-page container
        const pageSprite1 = new PIXI.Sprite(PIXI.Assets.get('p7_new_content_PH'));
        pageSprite1.anchor.set(0.5);
        pageSprite1.scale.set(2.6);
        pageSprite1.x = 0;
        pageSprite1.y = 0;

        gameAssets.page[i].addChild(pageSprite1);
        gameAssets.page[i].visible = false;
        gameAssets.page[i].interactive = true;
        gameAssets.page[i].mask = gameAssets.PageMask;
        gameAssets.page[i].y = 2320;

        // Define scroll bounds
        const minY = -pageSprite1.y - pageSprite1.height + gameAssets.PageMask.height + 2430; // Bottom bound
        const maxY = 2320; // Top bound

        // Pointer down event
        gameAssets.page[i].on("pointerdown", (event) => {
          if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === "touch") {
            gameAssets.pointerDown = true;
            gameAssets.startPointerY = event.data.global.y;
            gameAssets.startContainerY = gameAssets.page[i].y;
            gameAssets.page[i].cursor = "grabbing";
          }
        });

        // Pointer move event
        gameAssets.page[i].on("pointermove", (event) => {
          if (gameAssets.pointerDown) {
            const deltaY = event.data.global.y - gameAssets.startPointerY;
            let newY = gameAssets.startContainerY + deltaY;
            gameAssets.page[i].y = Math.min(maxY, Math.max(newY, minY));

            if (gameAssets.page[gameAssets.page.length - 1].y < -2265) {
              gameAssets.arrow.visible = false;
            } else {
              gameAssets.arrow.visible = true;
            }
            globalData.ftueIsScroll = false;
          }
        });

        // Pointer up event
        gameAssets.page[i].on("pointerup", () => {
          gameAssets.pointerDown = false;
          gameAssets.page[i].cursor = "grab";
        });

        gameAssets.page[i].on("pointerupoutside", () => {
          gameAssets.pointerDown = false;
          gameAssets.page[i].cursor = "grab";
        });
      }
    }

    containers.pageContainer.addChild(gameAssets.page[i]);
  }
}


function pagination() {
  globalData.tutorialPageSize = 11
  if (globalData.isJackpotActive) {
    globalData.tutorialPageSize = 12
  }
  for (let i = 0; i < globalData.tutorialPageSize; i++) {
    gameAssets.pageIcons[i] = new PIXI.Sprite(
      PIXI.Assets.get("tutorialNormal")
    );
    if (globalData.isJackpotActive) {
      gameAssets.pageIcons[i].x = i * 90 - 480;
      gameAssets.pageIcons[i].scale.set(0.78)
    } else {
      gameAssets.pageIcons[i].x = i * 100 - 500;
      gameAssets.pageIcons[i].scale.set(0.85)
    }
    gameAssets.pageIcons[i].y = containers.pageContainer.height / 7.2;
    gameAssets.pageIcons[i].anchor.set(0.5);
    // gameAssets.pageIcons[i].scale.set(0.3)
    gameAssets.pageIcons[i].interactive = false;

    gameAssets.selected = new PIXI.Sprite(PIXI.Assets.get("tutorialSelected"));
    gameAssets.selected.anchor.set(0.5);
    gameAssets.selected.visible = false;
    gameAssets.pageIcons[i].addChild(gameAssets.selected);

    gameAssets.pageIcons[i].on('pointerdown', (event) => {
      if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
        var self = event.currentTarget;
        var index = this.pageIcons.indexOf(self);
        this.pageIcons[index].children[0].visible = true;
        gameAssets.currentPage = index;
        showPage(gameAssets.currentPage);
        playPlus();
      }
    });
    containers.pageContainer.addChild(gameAssets.pageIcons[i]);
  }
  const nextButton = new PIXI.Sprite(PIXI.Assets.get("rightNormal"));
  nextButton.anchor.set(0.5);
  const width1 = nextButton.width;

  nextButton.x = globalData.isJackpotActive ? 620 : 600;
  nextButton.y = 800;
  nextButton.interactive = true;
  const nextHover = new PIXI.Sprite(PIXI.Assets.get("rightHover"));
  nextHover.anchor.set(0.5);
  nextButton.addChild(nextHover);
  nextHover.visible = false;
  nextButton.cursor = 'pointer'

  nextButton.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      if (gameAssets.currentPage < globalData.tutorialPageSize - 1) {

        showPage(++gameAssets.currentPage);
        playPlus();

        if (gameAssets.currentPage == globalData.tutorialPageSize - 1 && globalData.showAutoAndTurbo) {
          gameAssets.arrow.visible = true;
        } else if (gameAssets.currentPage == 2 && gameAssets.page[2].y > gameAssets.prizePosition) {
          gameAssets.arrow.visible = true;
        } else {
          gameAssets.arrow.visible = false;
        }
      } else {
        playDisable();
      }
    }
  });

  nextButton.on("pointerover", () => {
    nextHover.visible = true;
  });
  nextButton.on("pointerout", () => {
    nextHover.visible = false;
  });

  const backButton = new PIXI.Sprite(PIXI.Assets.get("leftNormal"));
  backButton.anchor.set(0.5);
  const width = backButton.width;
  backButton.x = globalData.isJackpotActive ? -580 : -600;
  backButton.y = 800;
  backButton.interactive = true;
  const backHover = new PIXI.Sprite(PIXI.Assets.get("leftHover"));
  backHover.anchor.set(0.5);
  backButton.addChild(backHover);
  backHover.visible = false;
  backButton.cursor = 'pointer'
  backButton.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      if (gameAssets.currentPage > 0) {
        showPage(--gameAssets.currentPage);
        playMinus();

        if (gameAssets.currentPage === 2 && gameAssets.page[2].y > gameAssets.prizePosition) {
          gameAssets.arrow.visible = true;
        } else {
          gameAssets.arrow.visible = false;
        }
      } else {
        playDisable();
      }
    }
  });

  backButton.on("pointerover", () => {
    backHover.visible = true;
  });
  backButton.on("pointerout", () => {
    backHover.visible = false;
  });
  containers.pageContainer.addChild(nextButton, backButton);
  showPage(0);
}

function showPage(index) {
  for (let pageNumber = 0; pageNumber < globalData.tutorialPageSize; pageNumber++) {
    gameAssets.page[pageNumber].visible = false;
    gameAssets.pageIcons[pageNumber].children[0].visible = false;
  }
  gameAssets.pageIcons[index].children[0].visible = true;
  gameAssets.page[index].visible = true;
}

function disable() {
  containers.pageContainer.visible = false;
  changeBackGroundInteractiveState(true)
  if (globalData.isJackpotActive) {
    showJackpotPanel()
    showGrandJackpotWin(globalData.grandCurrentJackpotValue)
    showMajorJackpotWin(globalData.majorCurrentJackpotValue)
    showMinorJackpotWin(globalData.minorCurrentJackpotValue)
  } else {
    hideJackpotPanel();
  }
  // gsap.delayedCall(0.01, () => {
  //   tweenFadeAppear(gameAssets.gameUI, true);
  // });
}

function skip(language) {
  gameAssets.skip = language == "English" ? new PIXI.Sprite(PIXI.Assets.get("skip")) : new PIXI.Sprite(PIXI.Assets.get("skip_tag"));
  gameAssets.skip.anchor.set(0.5);
  const scale = language == "English" ? 1.6 : 1.1;
  gameAssets.skip.scale.set(scale);
  gameAssets.skip.position.set(442, -715);
  gameAssets.skip.interactive = true;
  gameAssets.skip.cursor = "pointer";
  containers.pageContainer.addChild(gameAssets.skip);
  gameAssets.skip.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') { disable(); }
  });

  const skipHitButtonGraphic = new PIXI.Graphics();
  skipHitButtonGraphic.beginFill(0x202020, 1);
  skipHitButtonGraphic.drawRect(340, 19, 100, 48);
  skipHitButtonGraphic.endFill();
  skipHitButtonGraphic.pivot.set(0.5)
  skipHitButtonGraphic.alpha = 0.01
  gameAssets.skip.addChild(skipHitButtonGraphic)

}

const resetPixiGame = (x, y) => {
  containers.rootContainer.x = 0;
  containers.rootContainer.y = 0;
};

export {
  containers,
  gameAssets,
  uiCreated,
  instances,
  demoWin,
  rebootButton,
  showErrorPopup,
  ShowInsufficientBalancePopup,
  centerJeepney,
  changeRoundNumber,
  restartGame,
  updateLoopGame,
  updateTotalBet,
  pendingGameUpdate,
  updateBalance,
  checkJeepnyCrash,
  handleGameState,
  createAppUI,
  resetPixiGame,
  resizeGameUI,
  showManualPopup,
  parseJackpotResult,
  stopBg,
  setSessionExpired,
  formatBalance,
  showGrandJackpotWin,
  showMajorJackpotWin,
  showMinorJackpotWin,
  showJackpotPanel,
  hideJackpotPanel,
  checkGrandJackpotVisible,
  checkMajorJackpotVisible,
  controlJackpotWinSpine,
  ftueScroll,
  ftuePrizeScroll,
  arrowVisibility,
  // showRightJeepney,
  // showLeftJeepney,
  // showFrontJeepney
}
